/**
 * @license
 * @qwik.dev/core 2.0.0-beta.29-dev+339edbb
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isBrowser as Zn, isServer as Kn } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as Xn } from "@qwik.dev/core/preloader";

const te = !1;

const ne = globalThis;

const ee = ne.qDev !== !1;

const re = ne.qDynamicPlatform !== !1;

const ie = ne.qTest === !0;

const se = ne.qRuntimeQrl === !0;

const oe = t => {
    ee && Object.seal(t);
};

const le = ee ? "background: #564CE0; color: white; padding: 2px 3px; border-radius: 2px; font-size: 0.8em;" : "";

const ue = /*#__PURE__*/ new Set;

const ce = (t, ...n) => {
    if (ee) {
        const e = "warn" + t;
        if (!ue.has(e)) {
            ue.add(e);
            fe(t, ...n);
        }
    }
};

const fe = (t, ...n) => {
    ee && console.warn("%cQWIK WARN", le, t, ...n);
};

const ae = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    !ie && console.error("%cQWIK ERROR", le, s.message, ...e, s.stack);
    t && !ie && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const he = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const r = t[e << 1];
        if (r === n) {
            return e << 1;
        }
        r < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const de = (t, n, e, s, o = !1) => {
    const r = he(t, n, s);
    r >= 0 ? e != null || o ? t[r + 1] = e : t.splice(r, 2) : (e != null || o) && t.splice(r ^ -1, 0, n, e);
};

const $e = (t, n, e) => {
    const s = he(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const pe = (t, n, e) => he(t, n, e) >= 0;

const ye = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const me = t => typeof t === "object" && t !== null;

const we = t => Array.isArray(t);

const be = t => typeof t === "string";

const ve = t => typeof t === "function";

const ge = (t, n = []) => {
    const e = ((t, ...n) => {
        if (ee) {
            const e = [ "Error while serializing class or style attributes", "Scheduler not found", "track() received object, without prop to track", "Only primitive and object literals can be serialized. {{0}}", "You can render over a existing q:container. Skipping render().", "QRL is not a function", "Dynamic import {{0}} not found", "Unknown type argument", "Actual value for useContext({{0}}) can not be found, make sure some ancestor component has set a value using useContextProvider(). In the browser make sure that the context was used during SSR so its state was serialized.", "Invoking 'use*()' method outside of invocation context.", "Calling a 'use*()' method outside 'component$(() => { HERE })' is not allowed. 'use*()' methods provide hooks to the 'component$' state and lifecycle, ie 'use' hooks can only be called synchronously within the 'component$' function or another 'use' method.\nSee https://qwik.dev/docs/core/tasks/#use-method-rules", 'The provided Context reference "{{0}}" is not a valid context created by createContextId()', "SsrError(tag): {{0}}", "QRLs can not be resolved because it does not have an attached container. This means that the QRL does not know where it belongs inside the DOM, so it cant dynamically import() from a relative path.", "QRLs can not be dynamically resolved, because it does not have a chunk path", "{{0}}\nThe JSX ref attribute must be a Signal", "Serialization Error: Deserialization of data type {{0}} is not implemented", "Serialization Error: Expected vnode for ref prop, but got {{0}}", "Serialization Error: Cannot allocate data type {{0}}", "Serialization Error: Missing root id for {{0}}", "Serialization Error: Serialization of data type {{0}} is not implemented", "Serialization Error: Unvisited {{0}}", "Serialization Error: Missing QRL chunk for {{0}}", "{{0}}\nThe value of the textarea must be a string found {{1}}", "Unable to find q:container", "Element must have 'q:container' attribute.", "Unknown vnode type {{0}}.", "Materialize error: missing element: {{0}} {{1}} {{2}}", "Cannot coerce a Signal, use `.value` instead", "useComputed$ QRL {{0}} {{1}} cannot return a Promise", '===\nQwik version {{0}} already imported while importing {{1}}.\nThis can lead to issues due to duplicated shared structures.\nVerify that the Qwik libraries you\'re using are in "resolve.noExternal[]" and in "optimizeDeps.exclude".\n===\n', "WrappedSignal is read-only", "Attribute value is unsafe for SSR {{0}}", "SerializerSymbol function returned rejected promise", "Serialization Error: Cannot serialize function: {{0}}" ];
            let s = e[t] ?? "";
            n.length && (s = s.replaceAll(/{{(\d+)}}/g, (t, e) => {
                let s = n[e];
                s && me(s) && s.constructor === Object && (s = JSON.stringify(s).slice(0, 50));
                return s;
            }));
            return `Code(Q${t}): ${s}`;
        }
        return `Code(Q${t}) https://github.com/QwikDev/qwik/blob/build/v2/packages/qwik/src/core/shared/error/error.ts#${n.join()}L${9 + t}`;
    })(t, ...n);
    return ((t, ...n) => {
        const e = ae(ee, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Se = "<sync>";

const ke = t => typeof t === "function" && typeof t.getSymbol === "function";

const ya = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const xe = "q:type";

const qe = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const Re = 124;

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const Ce = "q:renderFn";

const je = "q:targetEl";

const Ee = "⚡️";

const Oe = "q:slot";

const _e = "q:s";

const Ae = "q:style";

const Pe = "style[q\\:style]";

const Ie = Pe + ",style[q\\:sstyle]";

const Ne = "q:sstyle";

const Me = "q:ctx";

const Te = "q:brefs";

const Fe = (t, n) => t["qFuncs_" + n] || [];

const ze = "q:base";

const De = "q:container-island";

const Le = "/" + De;

const Ue = "q:ignore";

const We = "/" + Ue;

const Qe = "q:container";

const Ve = "/" + Qe;

const Je = "q:template";

const Be = "http://www.w3.org/1999/xhtml";

const He = "http://www.w3.org/2000/svg";

const Ye = "http://www.w3.org/1998/Math/MathML";

const Ge = "qRender";

const Ke = "q:key";

const Ze = "q:props";

const tr = "q:seq";

const nr = "q:seqIdx";

const er = "q:p";

const rr = "q:ps";

const sr = ":on";

const or = ":onIdx";

const lr = ":onFlags";

const ur = ":";

const cr = "dangerouslySetInnerHTML";

const fr = "__scopedStyleIdPrefix__";

const ar = 100;

const hr = t => !!t && typeof t == "object" && typeof t.then === "function";

const dr = (t, n, e) => {
    try {
        const s = t();
        return hr(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const $r = (t, n) => hr(t) ? t.then(n) : n(t);

const pr = t => {
    throw t;
};

function n(t, n = pr) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!hr(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = ar;
    const r = async e => {
        for (;hr(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!hr(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(r) : r(s);
}

const yr = t => Ee + t;

const mr = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + yr(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const wr = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && t.charCodeAt(3) === 58;

function e(t) {
    if (t.endsWith("$")) {
        const [n, e] = function s(t) {
            let n;
            let e = -1;
            if (t.startsWith("on")) {
                n = "q-e:";
                e = 2;
            } else if (t.startsWith("window:on")) {
                n = "q-w:";
                e = 9;
            } else if (t.startsWith("document:on")) {
                n = "q-d:";
                e = 11;
            }
            return [ n, e ];
        }(t);
        if (e !== -1) {
            const s = t.slice(e, -1);
            return s === "DOMContentLoaded" ? n + "-d-o-m-content-loaded" : function o(t, n) {
                const e = br(t);
                return n + e;
            }(s.charAt(0) === "-" ? s.slice(1) : s.toLowerCase(), n);
        }
    }
    return null;
}

const br = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const vr = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const gr = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const Sr = t => {
    if (!t) {
        return "";
    }
    if (be(t)) {
        return t.trim();
    }
    const n = [];
    if (we(t)) {
        for (const e of t) {
            const t = Sr(e);
            t && n.push(t);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const kr = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

function r(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = Sr(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = (t => {
            if (t == null) {
                return "";
            }
            if (typeof t == "object") {
                if (we(t)) {
                    throw ge(0, [ t, "style" ]);
                }
                {
                    const n = [];
                    for (const e in t) {
                        if (Object.prototype.hasOwnProperty.call(t, e)) {
                            const s = t[e];
                            s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(kr(e) + ":" + xr(e, s)));
                        }
                    }
                    return n.join(";");
                }
            }
            return t + "";
        })(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function r(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const xr = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => vr.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const qr = Zn ? document : void 0;

const Rr = Zn && qr.createElement("link").relList.supports("modulepreload") ? "modulePreload" : "preload";

const Cr = /\.[mc]?js$/;

const jr = t => {
    let n = Er.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            zt: t,
            Tt: Cr.test(t) ? 0 : 3,
            Dt: n,
            Lt: 1,
            Ut: Date.now(),
            Wt: 0,
            Qt: 0
        }))(t, e);
        Er.set(t, n);
    }
    return n;
};

const Er = new Map;

let Or = 0;

const _r = [];

const Ar = () => {
    if (!_r.length) {
        return;
    }
    for (;_r.length; ) {
        const t = _r[0];
        const n = t.Lt;
        const e = 1 - n;
        const s = 5;
        if (!(e >= .99 || Or < s)) {
            break;
        }
        _r.shift();
        Pr(t);
    }
};

const Pr = t => {
    if (t.Tt >= 2) {
        return;
    }
    Or++;
    const n = Date.now();
    t.Wt = n - t.Ut;
    t.Tt = 2;
    const e = qr.createElement("link");
    e.href = "" + new URL("undefined" + t.zt, qr.baseURI);
    e.rel = Rr;
    e.as = "script";
    e.onload = e.onerror = () => {
        Or--;
        const s = Date.now();
        t.Qt = s - n;
        t.Tt = 4;
        e.remove();
        Ar();
    };
    qr.head.appendChild(e);
};

const Ir = (t, n, e) => {
    if (e?.has(t)) {
        return;
    }
    const s = t.Lt;
    t.Lt = n;
    if (s - t.Lt < .01) {
        return;
    }
    if (t.Dt) {
        e ||= new Set;
        e.add(t);
        const n = 1 - t.Lt;
        for (const s of t.Dt) {
            const t = jr(s.zt);
            if (t.Lt === 0) {
                continue;
            }
            let o;
            if (n === 1 || n >= .99 && Mr < 100) {
                Mr++;
                o = Math.min(.01, 1 - s.Vt);
            } else {
                const e = 1 - s.Vt * n;
                const r = s.Jt;
                const i = e / r;
                o = Math.max(.02, t.Lt * i);
                s.Jt = i;
            }
            Ir(t, o, e);
        }
    }
};

const Nr = (t, n) => {
    const e = jr(t);
    e && e.Lt > n && Ir(e, n);
};

let Mr;

Zn && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            Mr = 0;
            let n = 0;
            if (Array.isArray(t)) {
                for (let e = t.length - 1; e >= 0; e--) {
                    const s = t[e];
                    typeof s === "number" ? n = 1 - s / 10 : Nr(s, n);
                }
            } else {
                Nr(t, n);
            }
            Zn && Ar();
        })(t);
    }
});

const Tr = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const Fr = ",";

const zr = "2.0.0-beta.29-dev+339edbb";

const Dr = () => ({
    isServer: Kn,
    importSymbol(t, n, e) {
        if (Kn) {
            const t = ya(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw ge(6, [ e ]);
        }
        if (!n) {
            throw ge(14, [ e ]);
        }
        if (!t) {
            throw ge(13, [ n, e ]);
        }
        const s = "" + Lr(t.ownerDocument, t, n);
        const o = new URL(s);
        o.hash = "";
        const r = o.href;
        return import(r).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const Lr = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(ze) ?? s, s);
    return new URL(e, o);
};

let Ur = /*#__PURE__ */ Dr();

const Wr = t => Ur = t;

const Qr = () => Ur;

const Vr = () => {
    if (re) {
        return Ur.isServer;
    }
    return !1;
};

const Jr = t => t.nodeType === 1;

const Br = t => t === "foreignObject";

const Hr = t => t === "svg" || Br(t);

const Yr = t => t === "math";

function i(t, n, e, s = !1) {
    const o = t.ownerDocument.createElementNS(e, n);
    for (const n of t.attributes) {
        n.name !== ur && o.setAttribute(n.name, n.value);
    }
    if (s) {
        for (const n of t.childNodes) {
            const t = n.nodeType;
            t === 3 ? o.appendChild(n.cloneNode()) : t === 1 && o.appendChild(i(n, n.localName, e, s));
        }
    }
    return o;
}

const Gr = {
    elementNamespace: Be,
    elementNamespaceFlag: 0
};

function s(t, n) {
    const e = !t || !!Fo(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && Br(Fo(t));
    let o = Be;
    let r = 0;
    const i = typeof n === "string" || so(n);
    if (i && function c(t) {
        if (typeof t === "string") {
            return Hr(t);
        }
        if (so(t)) {
            return Hr(Fo(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = He;
        r = 512;
    } else if (i && function l(t) {
        if (typeof t === "string") {
            return Yr(t);
        }
        if (so(t)) {
            return Yr(Fo(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Ye;
        r = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? He : e ? Ye : Be;
        r = t.flags & 1536;
    }
    Gr.elementNamespace = o;
    Gr.elementNamespaceFlag = r;
    return Gr;
}

const Xr = Symbol();

class Kr {
    [Xr]=void 0;
}

class Zr {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [Xr]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class ti extends Zr {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, r, i, c) {
        super(n, e, s, o, r);
        this.key = t;
        this.firstChild = i;
        this.lastChild = c;
    }
}

class ni extends ti {
    node;
    elementName;
    constructor(t, n, e, s, o, r, i, c, l, u) {
        super(t, n, e, s, o, r, i, c);
        this.node = l;
        this.elementName = u;
    }
}

class ei extends Zr {
    node;
    text;
    constructor(t, n, e, s, o, r, i) {
        super(t, n, e, s, o);
        this.node = r;
        this.text = i;
    }
}

const ri = [];

const ii = [];

function o(t, n) {
    const e = h(n).priority;
    let s = ri.length;
    for (let t = 0; t < ri.length; t++) {
        const n = h(ri[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    ri.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function l() {
    for (let t = 0; t < ri.length; t++) {
        const n = ri[t];
        let e = !1;
        for (let t = 0; t < ii.length; t++) {
            const s = ii[t];
            if (ol(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function u(t, n) {
    ii.push(t);
    f(t, n, !0);
    n.o++;
}

function c(t, n) {
    const e = ii.indexOf(t);
    if (e !== -1) {
        const t = ii.length - 1;
        e !== t && (ii[e] = ii[t]);
        ii.pop();
        n.o--;
    }
    o(n, t);
}

function f(t, n, e) {
    e || (t.flags &= -257);
    const s = ri.indexOf(t);
    if (s !== -1) {
        ri.splice(s, 1);
        n.o--;
    }
}

const si = new WeakMap;

const oi = ":nodeProps";

const li = ":nodeDiff";

const ui = ":signal";

function a(t, n, e) {
    n.position = e;
    e && Kt(e) && function s(t, n, e) {
        f(e, t);
        const s = h(e);
        if (s === n) {
            return;
        }
        const o = s.afterFlushTasks;
        if (o && o.length > 0) {
            const t = n.afterFlushTasks;
            t ? t.push(...o) : n.afterFlushTasks = o;
        }
        const r = s.extraPromises;
        if (r && r.length > 0) {
            const t = n.extraPromises;
            t ? t.push(...r) : n.extraPromises = r;
        }
        const i = s.journal;
        if (i && i.length > 0) {
            const t = n.journal;
            t ? t.push(...i) : n.journal = i;
        }
    }(t, n, e);
}

function h(t) {
    return si.get(t) ?? null;
}

class ci {
    Bt;
    $=void 0;
    O=null;
    Ht=null;
    constructor(t, n) {
        this.O = t || ml()?.O || null;
        this.Bt = n;
    }
    trigger() {
        Wu(this.O, this, this.$);
    }
    force() {
        Wu(this.O, this, this.$);
    }
    get untrackedValue() {
        return this.Bt;
    }
    set untrackedValue(t) {
        this.Bt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = ml();
        if (!n) {
            return t;
        }
        this.O === null && (this.O = n.O);
        const e = n.vt;
        if (e) {
            Du(this.$ ||= new Set, e);
            Lu(e, this);
            (import.meta.env.TEST ? !Au(this.O) : Kn) && Uu(e, this.O);
        }
        return t;
    }
    set value(t) {
        if (t !== this.Bt) {
            this.Bt = t;
            Wu(this.O, this, this.$);
        }
    }
    valueOf() {
        if (ee) {
            throw ge(28);
        }
    }
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.Bt
        };
    }
}

const fi = Symbol();

const ai = Symbol();

const hi = Symbol();

const di = Symbol();

const $i = Symbol();

const pi = Symbol();

const yi = [];

const mi = {};

Object.freeze(yi);

Object.freeze(mi);

function d(t) {
    return new Proxy({}, new wi(t));
}

class wi {
    owner;
    $=void 0;
    O=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === fi) {
            return this.owner.constProps;
        }
        if (n === ai) {
            return this.owner.varProps;
        }
        if (n === hi) {
            return this.owner;
        }
        if (n === di) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = gi(this.owner, n);
            n in this.owner.varProps && bi(this, n);
        }
        return s instanceof Gi && s.R & 4 ? s.value : s;
    }
    set(t, n, s) {
        if (n === hi) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === fi) {
            this.owner.constProps = s;
        } else if (n === ai) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === mi ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                vi(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && vi(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === fi || n === ai) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && bi(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const bi = (t, n) => {
    const e = ml();
    e && t.O === null && e.O && (t.O = e.O);
    const s = e?.vt;
    s && Wn(t.owner._proxy, n, t, s);
};

const vi = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.$, n);
    e && Wu(t.O, t, e);
    return !!e;
};

const gi = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const Si = (t, n) => ki(t)?.[n] || xi(t)?.[n] || null;

const ki = t => {
    if (!t) {
        return null;
    }
    return ai in t ? "children" in t ? {
        ...t[ai],
        children: t.children
    } : t[ai] : t;
};

const xi = t => {
    if (!t) {
        return null;
    }
    return fi in t ? t[fi] : null;
};

const qi = t => t && ai in t;

const Ri = Symbol();

class Ci {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const ji = Symbol();

const Ei = Symbol();

const Oi = Symbol();

function $(t, n, e) {
    t[Xr] || (Kn && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(Te, new Map) : t[Xr] = new Map);
    const o = t[Xr];
    let r = o.get(n);
    if (!r) {
        r = new Ci(t, n);
        o.set(n, r);
    }
    e && (r.data = e);
    return r;
}

const _i = (t, n) => (e, s) => {
    const o = yn();
    o.vt = $(t, ":");
    o.O = n || void 0;
    return dn(o, () => {
        if (ve(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (zu(e)) {
            return e.value;
        }
        if (me(e) && Zu(e)) {
            Wn(Yu(e), Oi, Hu(e), o.vt);
            return e;
        }
        throw ge(2);
    });
};

class Ai extends ci {
    Yt;
    R;
    [Xr]=void 0;
    constructor(t, n, e = 17) {
        super(t || ml()?.O, Ri);
        this.Yt = n;
        this.R = e;
    }
    invalidate() {
        this.R |= 1;
        const t = yn();
        t.O = this.O || void 0;
        const e = n($n.bind(this, t, this.j));
        e && e.catch(t => {
            this.O ? this.O.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get untrackedValue() {
        this.j();
        return this.Bt;
    }
    set untrackedValue(t) {
        this.Bt = t;
    }
    j() {
        if (!(this.R & 1)) {
            return;
        }
        const t = this.Yt;
        Fu(t);
        const n = ml();
        const e = n?.vt;
        if (n) {
            const t = $(this, ".");
            y(this.O, t);
            n.vt = t;
        }
        try {
            const e = t.getFn(n)();
            if (hr(e)) {
                throw ge(29, [ t.dev ? t.dev.file : "", t.ft ]);
            }
            this.R &= -2;
            super.value = e;
        } finally {
            n && (n.vt = e);
        }
    }
}

class Pi {
    Gt;
    Xt=null;
    Kt=!1;
    Zt=!0;
    tn;
    nn;
    en;
    constructor(t) {
        this.Gt = t;
    }
    get track() {
        return this.tn ||= _i(this.Gt, this.Gt.O);
    }
    get abortSignal() {
        return (this.en ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.Gt.Bt;
        if (t !== Ri) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.nn ||= []).push(t);
    }
}

class Ii extends Ai {
    rn=!1;
    sn=void 0;
    m=void 0;
    k=void 0;
    ln=null;
    un=[];
    cn=1;
    jt=0;
    fn;
    [Xr]=void 0;
    constructor(t, n, e = 17, s) {
        super(t, n, e);
        const o = s?.interval;
        const r = s?.concurrency ?? 1;
        const i = s?.initial;
        const c = s?.timeout;
        const l = s?.eagerCleanup;
        const u = s?.clientOnly;
        if (i !== void 0) {
            const t = typeof i === "function" ? i() : i;
            this.Bt = t;
        }
        this.cn = r;
        c && (this.fn = c);
        l && (this.R |= 32);
        u && (this.R |= 64);
        o && (this.interval = o);
    }
    get untrackedValue() {
        this.j();
        if (this.ln?.Xt) {
            if (this.Bt === Ri || (import.meta.env.TEST ? Vr() : Kn)) {
                throw this.ln?.Xt;
            }
            return this.Bt;
        }
        if (this.sn) {
            throw this.sn;
        }
        if ((import.meta.env.TEST ? Vr() : Kn) && this.R & 64 && this.Bt === Ri) {
            throw Error("Cannot read .value from clientOnly");
        }
        return this.Bt;
    }
    set untrackedValue(t) {
        this.Bt = t;
    }
    get loading() {
        const t = this.untrackedLoading;
        const n = ml();
        if (n && (this.O ||= n.O || null)) {
            const t = n.vt;
            if (t) {
                Du(this.m ||= new Set, t);
                Lu(t, this);
                Uu(t, this.O);
            }
        }
        return t;
    }
    set untrackedLoading(t) {
        if (t !== this.rn) {
            this.rn = t;
            Wu(this.O, this, this.m);
        }
    }
    get untrackedLoading() {
        this.j();
        if ((import.meta.env.TEST ? Vr() : Kn) && this.ln?.Xt) {
            throw this.ln?.Xt;
        }
        return this.rn;
    }
    get error() {
        const t = this.untrackedError;
        const n = ml();
        if (n && (this.O ||= n.O || null)) {
            const t = n.vt;
            if (t) {
                Du(this.k ||= new Set, t);
                Lu(t, this);
                Uu(t, this.O);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.sn) {
            this.sn = t;
            Wu(this.O, this, this.k);
        }
    }
    get untrackedError() {
        return this.sn;
    }
    get interval() {
        return this.jt;
    }
    set interval(t) {
        this.an();
        this.jt = t;
        this.jt > 0 && this.$?.size && this.hn();
    }
    async invalidate() {
        this.R |= 1;
        this.an();
        if (this.$?.size || this.m?.size || this.k?.size) {
            await !0;
            this.j();
        }
    }
    abort(t) {
        this.ln && this.dn(this.ln, t);
    }
    q() {
        if (!(this.R & 32) || this.$n()) {
            return;
        }
        if (!(import.meta.env.TEST ? !Vr() : Zn)) {
            return;
        }
        setTimeout(() => {
            this.$n() || this.abort();
        });
    }
    async promise() {
        this.j();
        for (;this.ln?.Xt; ) {
            await (this.ln?.Xt);
        }
    }
    j() {
        if (!(this.R & 1)) {
            return;
        }
        if ((import.meta.env.TEST ? Vr() : Kn) && this.R & 64) {
            this.rn = !0;
            this.O?.serializationCtx.Et.add(this);
            return;
        }
        this.an();
        this.ln && this.dn(this.ln);
        const t = this.cn === 0 ? Infinity : this.cn;
        if (this.un.length >= t) {
            return;
        }
        this.R &= -2;
        const n = new Pi(this);
        this.ln = n;
        this.un.push(n);
        n.Xt = this.pn(n);
    }
    async pn(t) {
        const e = () => t === this.ln;
        this.untrackedLoading = !0;
        const s = this.Yt.resolved || await this.Yt.resolve();
        try {
            this.fn && (this.yn = setTimeout(() => {
                t.en?.abort();
                const n = Error("timeout");
                if (e()) {
                    this.untrackedError = n;
                    t.Zt = !1;
                }
            }, this.fn));
            const o = await n(s.bind(null, t));
            t.Xt = null;
            if (t.Zt) {
                const n = this.un.indexOf(t);
                if (n !== -1) {
                    for (let t = 0; t < n; t++) {
                        this.un[t].Zt = !1;
                    }
                }
                this.untrackedError = void 0;
                this.value = o;
            }
        } catch (n) {
            t.Xt = null;
            e() && (this.untrackedError = n);
        }
        if (e()) {
            clearTimeout(this.yn);
            if (this.R & 1) {
                this.j();
            } else {
                this.untrackedLoading = !1;
                this.hn();
            }
        }
    }
    async mn() {
        this.an();
        clearTimeout(this.yn);
        this.ln && await this.dn(this.ln);
        await Promise.all(this.un.map(t => t.Xt));
    }
    an() {
        if (this.wn !== void 0) {
            clearTimeout(this.wn);
            this.wn = void 0;
        }
    }
    hn() {
        if ((import.meta.env.TEST ? !Vr() : Zn) && this.jt > 0) {
            this.an();
            this.wn = setTimeout(this.invalidate.bind(this), this.jt);
            this.wn?.unref?.();
        }
    }
    $n() {
        return !!(this.$?.size || this.m?.size || this.k?.size);
    }
    async dn(t, n) {
        if (t.Kt) {
            return t.Xt;
        }
        t.Kt = !0;
        t.en?.abort(n);
        t.Xt = Promise.resolve(t.Xt).then(() => t.Xt = this.bn(t));
    }
    async bn(t) {
        const n = t.nn;
        if (n?.length) {
            const t = t => {
                const n = this.O?.handleError;
                n ? n(t, null) : console.error("Error in async signal cleanup", t);
            };
            await Promise.all(n.map(n => {
                try {
                    const e = n();
                    if (hr(e)) {
                        return e.catch(t);
                    }
                } catch (n) {
                    t(n);
                }
            }));
            n.length = 0;
        }
        const e = this.un;
        const s = e.indexOf(t);
        s !== -1 && e.splice(s, 1);
        this.j();
    }
}

const Ni = t => (n, ...e) => t.call(null, Fc(n), ...e);

class Mi extends Ai {
    constructor(t, n) {
        super(t, n, 17);
    }
    vn=!1;
    j() {
        if (!(this.R & 1)) {
            return;
        }
        Fu(this.Yt);
        const t = vl(this.Yt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.Bt === Ri ? e : this.Bt;
        const r = Sl(() => this.vn ? s?.(o) || o : n(o), this, ".", this.O);
        this.vn = !0;
        this.R &= -2;
        const i = this.vn && r !== "undefined" || r !== this.Bt;
        if (i) {
            this.Bt = r;
            Wu(this.O, this, this.$);
        }
    }
}

const Ti = (t, n) => new Ai(n?.container || null, t, Vu(n?.serializationStrategy || "always"));

const Fi = (t, n) => new Ii(n?.container || null, t, Vu(n?.serializationStrategy || "always"), n);

const zi = t => new Mi(null, t);

const Di = t => new ci(null, t);

const Li = /*#__PURE__*/ Ni(Ti);

const Ui = /*#__PURE__*/ Ni(Fi);

const Wi = Ni(zi);

const Qi = t => t.value;

const Vi = (t, n) => t[n];

const Ji = t => {
    if (t.length === 1) {
        if (zu(t[0])) {
            return t[0].Ht ||= new Gi(null, Qi, t, null);
        }
        if (Zu(t[0])) {
            return new Gi(null, Qi, t, null);
        }
        return t[0].value;
    }
    return new Gi(null, Vi, t, null);
};

const Bi = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!me(n)) {
        return n[e];
    }
    if (zu(n)) {
        if (n instanceof Gi && n.R & 4) {
            return n;
        }
        return Ji(t);
    }
    if (qi(n)) {
        const s = n[fi];
        const o = n[ai];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return Hi(n, t);
        }
    } else {
        const s = Yu(n);
        if (s) {
            const n = s[e];
            return Hi(n, t);
        }
    }
    return n[e];
};

const Hi = (t, n) => zu(t) ? t : Ji(n);

const Yi = (t, n) => {
    const e = Bi(t, n);
    if (e === $i) {
        return t[n];
    }
    return e;
};

class Gi extends ci {
    dt;
    ht;
    Ct;
    R;
    p=void 0;
    [Xr]=void 0;
    constructor(t, n, e, s, o = 5) {
        super(t, Ri);
        this.dt = e;
        this.ht = n;
        this.Ct = s;
        this.R = o;
    }
    invalidate() {
        this.R |= 1;
        try {
            this.j();
        } catch (t) {
            if (this.O && this.p) {
                this.O.setHostProp(this.p, ui, this);
                nn(this.O, this.p, 16);
            }
        }
        if (this.R & 2) {
            this.R &= -3;
            Wu(this.O, this, this.$);
        }
    }
    get untrackedValue() {
        this.j();
        return this.Bt;
    }
    j() {
        if (!(this.R & 1)) {
            return;
        }
        const t = Sl(() => this.ht(...this.dt), this, ".", this.O);
        this.R &= -3;
        const n = t !== this.Bt;
        if (n) {
            this.R |= 2;
            this.Bt = t;
        }
    }
    ct() {
        return this.ht === Qi && zu(this.dt[0]) ? this.dt[0] : this;
    }
    set value(t) {
        throw ge(31);
    }
    get value() {
        return super.value;
    }
}

function p(t, n) {
    io(n) && so(n) && Uo(n);
    const e = n[Xr];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        y(t, n);
    }
    e.clear();
}

function y(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof Ii) {
            w(s, n);
        } else if (s instanceof ci) {
            m(t, s, n);
        } else if (qi(s)) {
            const t = s[di];
            b(t, n);
        } else if (t.h.has(s)) {
            const e = t.h.get(s);
            const o = Hu(e);
            b(o, n);
        }
    }
    e.clear();
}

function m(t, n, e) {
    const s = n.$;
    s && s.has(e) && s.delete(e);
    if (n instanceof Gi && !s?.size) {
        n.p = void 0;
        p(t, n);
    }
}

function w(t, n) {
    const e = t.$;
    e && e.has(n) && e.delete(n);
    const s = t.m;
    s && s.has(n) && s.delete(n);
    const o = t.k;
    o && o.has(n) && o.delete(n);
    t.q();
}

function b(t, n) {
    const e = t?.$;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

class Xi {
    data;
    constructor(t) {
        this.data = t;
    }
}

const Ki = (t, n) => {
    if (typeof t === "string") {
        const e = Tn(n);
        qc(Rc(e, t));
    }
    return null;
};

function v(t, n) {
    Ki(this, n);
    const e = xc[0];
    e.value = n.type === "number" ? n.valueAsNumber : n.value;
}

function g(t, n) {
    Ki(this, n);
    const e = xc[0];
    e.value = n.checked;
}

function S(t, n) {
    Ki(this, n);
    if (xc) {
        for (const t of xc) {
            t instanceof Ii && t.R & 64 && t.j();
        }
    }
}

const Zi = Object.prototype.hasOwnProperty;

class ts {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, r, i, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!i;
        this.key = r === null || r === void 0 ? null : typeof r === "string" ? r : "" + r;
        this.varProps = !n || Tr(n) ? mi : n;
        this.constProps = !e || Tr(e) ? null : e;
        ee && c && (this.dev = {
            ...c,
            stack: Error().stack?.split("\n").slice(2).join("\n")
        });
        oe(this);
    }
    get props() {
        return this._proxy ||= d(this);
    }
}

const ns = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const es = t => {
    if (ee) {
        if (t instanceof ts) {
            return !0;
        }
        if (me(t) && Zi.call(t, "key") && Zi.call(t, "props") && Zi.call(t, "type")) {
            if (qi(t)) {
                return !1;
            }
            fe('Duplicate implementations of "JSXNode" found');
            return !0;
        }
        return !1;
    }
    return t instanceof ts;
};

const rs = "bind:value";

const is = "bind:checked";

const ss = Object.prototype.hasOwnProperty;

const os = (t, n, e, s, o, r, i) => new ts(t, n, e, s, o, r, !1, i);

const ls = (t, n, s, o, r, i, c) => {
    let l = !1;
    let u = !1;
    let f = !1;
    let a = null;
    let h = null;
    if (typeof t === "string") {
        if (s) {
            const t = new Set;
            for (const n in s) {
                const o = e(n);
                if (o) {
                    if (!u) {
                        s = {
                            ...s
                        };
                        u = !0;
                    }
                    ss.call(s, o) && !t.has(o) || (s[o] = s[n]);
                    delete s[n];
                } else {
                    n === is ? h = s[n] : n === rs && (a = s[n]);
                }
                t.add(n);
            }
        }
        if (n) {
            const t = new Set;
            for (const s in n) {
                const o = e(s);
                if (o) {
                    if (!f) {
                        n = {
                            ...n
                        };
                        f = !0;
                    }
                    ss.call(n, o) && !t.has(o) || (n[o] = n[s]);
                    delete n[s];
                    l = !0;
                } else {
                    s === is ? h = n[s] : s === rs && (a = n[s]);
                }
                t.add(s);
            }
        }
        if (h || a) {
            if (!f) {
                n = {
                    ...n
                };
                f = !0;
            }
            n ||= {};
            if (h) {
                n && ss.call(n, is) && delete n[is];
                if (s && ss.call(s, is)) {
                    if (!u) {
                        s = {
                            ...s
                        };
                        u = !0;
                    }
                    delete s[is];
                }
                n.checked = h;
                const t = Oc(null, "_chk", g, null, [ h ]);
                if (s && ss.call(s, "q-e:input")) {
                    if (!u) {
                        s = {
                            ...s
                        };
                        u = !0;
                    }
                    const t = s["q-e:input"];
                    delete s["q-e:input"];
                    l = ns(n, "q-e:input", t) || l;
                }
                l = ns(n, "q-e:input", t) || l;
            } else if (a) {
                n && ss.call(n, rs) && delete n[rs];
                if (s && ss.call(s, rs)) {
                    if (!u) {
                        s = {
                            ...s
                        };
                        u = !0;
                    }
                    delete s[rs];
                }
                n.value = a;
                const t = Oc(null, "_val", v, null, [ a ]);
                if (s && ss.call(s, "q-e:input")) {
                    if (!u) {
                        s = {
                            ...s
                        };
                        u = !0;
                    }
                    const t = s["q-e:input"];
                    delete s["q-e:input"];
                    l = ns(n, "q-e:input", t) || l;
                }
                l = ns(n, "q-e:input", t) || l;
            }
        }
        if (n && ss.call(n, "className")) {
            if (!f) {
                n = {
                    ...n
                };
                f = !0;
            }
            n.class = n.className;
            n.className = void 0;
            l = !0;
            ee && ce(`jsx${c ? ` ${c.fileName}${c?.lineNumber ? ":" + c.lineNumber : ""}` : ""}: \`className\` is deprecated. Use \`class\` instead.`);
        }
        if (s && ss.call(s, "className")) {
            if (!u) {
                s = {
                    ...s
                };
                u = !0;
            }
            s.class = s.className;
            s.className = void 0;
            ee && ce(`jsx${c ? ` ${c.fileName}${c?.lineNumber ? ":" + c.lineNumber : ""}` : ""}: \`className\` is deprecated. Use \`class\` instead.`);
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!f) {
                    n = {
                        ...n
                    };
                    f = !0;
                }
                o ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!f) {
                    n = {
                        ...n
                    };
                    f = !0;
                }
                i ||= n.key;
                delete n.key;
            } else if (s && t in s) {
                if (!f) {
                    n = {
                        ...n
                    };
                    f = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!f) {
                    n = {
                        ...n
                    };
                    f = !0;
                }
                delete n[t];
            }
        }
    }
    return new ts(t, n, s, o, r, i, l || !0, c);
};

const us = (t, n, e, s) => hs(t, n, s);

const cs = (t, n, e, s, o) => hs(t, {
    ...e,
    ...n
}, o);

const fs = (t, n, e, s, o, r) => hs(t, {
    ...e,
    ...n,
    children: s
}, r);

const as = t => t.children;

const hs = (t, n, e, s, o) => ls(t, n, null, null, 0, e, o);

const ds = hs;

const $s = hs;

function k(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return ls(t, n, null, s.children, 0, o);
}

const ps = t => t.children;

const ys = (t, n) => new ts(as, null, null, t.children, 0, n);

const ms = (t, n, e, s, o) => {
    const r = pn(t.wt, e || n, t);
    if (e) {
        r.vt = $(e, ":");
        r.O = t;
    }
    let i;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, Ce));
    if (ke(s)) {
        o = o || t.getHostProp(n, Ze) || mi;
        "children" in o && delete o.children;
        i = s.getFn(r);
    } else if (Qc(s)) {
        const t = s;
        i = () => $n(r, t, [ o || mi, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        i = () => $n(r, t, [ o || mi ]);
    }
    const l = import.meta.env.TEST ? Vr() : Kn;
    const u = (e = 0) => dr(() => {
        if (!c) {
            t.setHostProp(n, nr, null);
            t.setHostProp(n, or, null);
        }
        e > 0 && io(n) && p(t, n);
        return $r(i(o), t => $r(r.gt, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < ar) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, sr);
        if (o) {
            return function r(t, n) {
                const e = R(t);
                let s = t;
                const o = "q-e:qvisible";
                return $r(e, t => {
                    const e = !t;
                    let r = null;
                    for (const i in n) {
                        if (Object.prototype.hasOwnProperty.call(n, i)) {
                            let c = t;
                            let l = i;
                            if (e) {
                                if (i !== o && !i.startsWith("q-d:") && !i.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    const [t, n] = C(s);
                                    s = n;
                                    r = t;
                                }
                                c = r;
                            }
                            if (c) {
                                c.type === "script" && i === o && (l = "q-d:qinit");
                                q(c, l, n[i]);
                            }
                        }
                    }
                    return s;
                });
            }(s, o);
        }
        return s;
    }, t => {
        if (hr(t) && e < ar) {
            return t.then(() => u(++e));
        }
        if (e >= ar) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function q(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    o == null ? s[n] = e : Array.isArray(o) ? o.push(...e) : s[n] = [ o, ...e ];
    const r = t.varProps[n];
    if (r) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...e ];
        s[n] = void 0;
    }
}

function R(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (es(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (we(t)) {
            n.push(...t);
        } else {
            if (hr(t)) {
                return $r(t, t => R(t));
            }
            if (zu(t)) {
                return R(t.untrackedValue);
            }
        }
    }
    return null;
}

function C(t) {
    if (es(t)) {
        const n = j();
        if (t.type !== ps && !Qc(t.type)) {
            return [ n, os(ps, null, null, [ t, n ], 0, null) ];
        }
        t.children == null ? t.children = n : we(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return [ n, t ];
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        const n = j();
        return [ n, os(ps, null, null, [ t, n ], 0, null) ];
    }
    if (we(t) && t.length > 0) {
        const [n, e] = C(t[0]);
        return [ n, t ];
    }
    return [ null, t ];
}

function j() {
    return new ts("script", null, {
        hidden: ""
    }, null, 0, null);
}

const ws = t => os(as, null, {
    [_e]: ""
}, t.children, 0, t.name ?? "");

const bs = Symbol();

const vs = () => null;

const gs = () => null;

const Ss = t => t.children;

const ks = (t, n) => hs(ys, {
    children: hs(xs, t)
}, n);

const xs = () => null;

let qs = null;

let Rs = null;

function E(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    Rs || (Rs = t.setAttributeNS);
                    Rs.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            qs || (qs = t.setAttribute);
            qs.call(t, n, e);
        })(t, n, e);
    }
}

function O(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const Cs = (t, n = [], e = {}) => {
    let s = null;
    const o = t[fi];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const r = e;
    const i = t[ai];
    for (const t in i) {
        n.includes(t) || (r[t] = i[t]);
    }
    return d(new ts(null, r, s, null, 0, null));
};

class js {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Es {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Os {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class _s {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class As {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const Ps = t => new js(t);

const Is = t => new Es(t);

const Ns = (t, n) => new Os(t, n);

const Ms = (t, n, e) => new _s(t, n, e);

const Ts = (t, n, e, s = null, o = !1) => new As(t, n, e, s, o);

const Fs = t => {
    if (t.mn) {
        try {
            t.mn();
        } catch (t) {
            ((t, ...n) => {
                ae(!1, t, ...n);
            })(t);
        }
        t.mn = null;
    }
};

function _(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    o || (o = bl(e, s));
    const r = o.O;
    const i = o.p;
    mo(r, i);
    let c = t;
    if (i.flags & 64) {
        let n;
        if (!(i.flags & 128)) {
            n = !0;
            i.flags |= 128;
        }
        const o = n ? r._ : null;
        const l = ho(i, er, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = ho(i, rr, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(i.flags & 32)) {
            return $n(o, c, [ e, s ]);
        }
    }, t => r.handleError(t, i));
}

function A(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = bl(t, n);
    typeof this === "string" && qc(Rc(e.O, this));
    const s = xc[0];
    return _(s, t, n, e);
}

function P(t) {
    return t.N === t.M ? t.T : null;
}

function I(t) {
    return t.D || P(t);
}

function N(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = P(t);
    return e === o ? null : e;
}

const zs = Object.prototype.hasOwnProperty;

function M(t, n, e, s, o, r) {
    import.meta.env.TEST && o && $o(n, fr, o);
    $o(n, e, r);
    en(t, Ts(n.node, e, s, o, (n.flags & 512) !== 0));
}

function T(t, n, e, s) {
    return {
        O: t,
        L: n,
        U: e,
        W: s,
        J: [],
        B: [],
        H: [],
        N: null,
        D: null,
        Y: null,
        T: null,
        M: null,
        G: null,
        X: null,
        K: null,
        Z: null,
        tt: null,
        nt: 0,
        et: 0,
        rt: !0,
        it: !1,
        st: {
            ot: new Xi({
                W: s,
                lt: !0
            }),
            ut: new Xi({
                W: s,
                lt: !1
            })
        }
    };
}

function F(t, n, e, s, o) {
    const r = t ?? T(n, e, s, o);
    (function i(t, n, e, s, o) {
        t.O = n;
        t.L = e;
        t.U = s;
        t.W = o;
        t.st.ot.data.W = o;
        t.st.ut.data.W = o;
        t.B.length = 0;
        t.H.length = 0;
    })(r, n, e, s, o);
    return r;
}

const Ds = (t, n, e, s, o, r, i) => z(F(i, t, n, o, r), e, s);

const Ls = (t, n, e, s, o, r, i, c, l = !1, u) => z(F(u, t, n, i, c), e, s, o, r, l);

function z(t, n, e, s = Lo(e), o = null, r = !1) {
    D(t, n, e, s, o, r);
    const i = G(t);
    if (hr(i)) {
        return i.finally(() => {
            X(t);
        });
    }
    X(t);
}

function D(t, n, e, s = Lo(e), o = null, r = !1) {
    const i = t.it;
    t.it = r || i;
    t.N = e;
    t.Y = null;
    t.D = s;
    t.T = o;
    t.M = e;
    V(t, n, !0);
    try {
        if (t.N.flags & 32) {
            return;
        }
        for (;t.J.length; ) {
            for (;t.nt < t.et; ) {
                if (typeof t.tt === "string") {
                    yt(t, t.tt);
                } else if (typeof t.tt === "number") {
                    yt(t, t.tt + "");
                } else if (t.tt && typeof t.tt === "object") {
                    if (es(t.tt)) {
                        const n = t.tt.type;
                        if (typeof n === "string") {
                            tt(t);
                            ut(t, t.tt, n);
                            const e = t.tt.constProps && zs.call(t.tt.constProps, cr) || zs.call(t.tt.varProps, cr);
                            e ? t.Y || K(t, !1) : W(t, t.tt.children, !0);
                        } else if (typeof n === "function") {
                            if (n === ps) {
                                tt(t);
                                ht(t, "F", t.tt.key);
                                W(t, t.tt.children, !0);
                            } else if (n === ws) {
                                tt(t);
                                H(t) || W(t, t.tt.children, !0);
                            } else if (n === bt) {
                                B(t);
                                W(t, t.tt.children, !0, !1);
                            } else if (n === gs) {
                                Z(t);
                            } else if (n === vs) {
                                Z(t);
                            } else {
                                tt(t);
                                dt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.tt)) {
                        W(t, t.tt, !1);
                    } else if (zu(t.tt)) {
                        ht(t, "S", null);
                        const n = t.tt instanceof Gi ? t.tt.ct() : t.tt;
                        const e = t.D?.[Xr]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Gi && (s = Rt(e, n));
                        if (!s) {
                            const e = t.Y || t.D;
                            W(t, L(t, () => kl(n, e, ".", t.O)), !0);
                        }
                    } else if (hr(t.tt)) {
                        ht(t, "A", null);
                        t.B.push(t.tt, t.Y || t.D);
                    }
                } else {
                    t.tt === bs || yt(t, "");
                }
                U(t);
            }
            Z(t);
            Y(t);
            Q(t);
        }
    } finally {
        t.it = i;
    }
}

function L(t, e) {
    try {
        return e();
    } catch (s) {
        if (hr(s)) {
            const o = s.then(() => n(e));
            t.B.push(o, t.Y || t.D);
            return null;
        }
        throw s;
    }
}

function U(t) {
    if (!t.rt) {
        t.rt = !0;
        return;
    }
    t.nt++;
    if (t.nt < t.et) {
        t.tt = t.Z[t.nt];
    } else if (t.J.length > 0 && t.J[t.J.length - 1] === !1) {
        return Q(t);
    }
    t.Y !== null ? t.Y = null : t.D = N(t, t.D);
}

function W(t, n, e, s = !0) {
    if (s && (n == null || e && we(n) && n.length === 0)) {
        K(t);
        return;
    }
    V(t, n, e);
    if (e) {
        const n = t.it || !!t.Y || !Lo(t.D);
        t.it = n;
        t.K = null;
        t.G = null;
        t.X = null;
        t.N = t.Y || t.D;
        t.D = Lo(t.N);
        t.Y = null;
    }
    t.rt = !1;
}

function Q(t) {
    const n = t.J.pop();
    if (n) {
        t.it = t.J.pop();
        t.K = t.J.pop();
        t.G = t.J.pop();
        t.X = t.J.pop();
        t.Y = t.J.pop();
        t.D = t.J.pop();
        t.N = t.J.pop();
    }
    t.tt = t.J.pop();
    t.et = t.J.pop();
    t.nt = t.J.pop();
    t.Z = t.J.pop();
    U(t);
}

function V(t, n, e) {
    t.J.push(t.Z, t.nt, t.et, t.tt);
    e && t.J.push(t.N, t.D, t.Y, t.X, t.G, t.K, t.it);
    t.J.push(e);
    if (Array.isArray(n)) {
        t.nt = 0;
        t.et = n.length;
        t.Z = n;
        t.tt = t.et > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.nt = 0;
        t.tt = null;
        t.Z = null;
        t.et = 0;
    } else {
        t.nt = 0;
        t.tt = n;
        t.Z = null;
        t.et = 1;
    }
}

function J(t) {
    if (t.Y) {
        return I(t);
    }
    return N(t, t.D) || P(t);
}

function B(t) {
    const n = t.tt;
    const e = n.key;
    t.D = ho(t.N, e, n => go(t.O.rootVNode, n));
    t.D = t.D && t.D.flags & 32 ? null : t.D;
    if (t.D == null) {
        t.Y = ro();
        $o(t.Y, Oe, e);
        t.Y.slotParent = t.N;
        $o(t.N, e, t.Y);
    }
}

function H(t) {
    const n = $l(t.N);
    const e = function s(t, n) {
        const e = t.tt;
        const s = e.constProps;
        if (s && typeof s == "object" && zs.call(s, "name")) {
            const e = s.name;
            if (n && e instanceof Gi) {
                return kl(e, n, ":", t.O);
            }
        }
        return gi(e, "name") || "";
    }(t, n);
    const o = n ? ho(n, e, null) : null;
    if (o == null) {
        t.Y = ro();
        $o(t.Y, Oe, e);
        n && $o(n, e, t.Y);
        Po(t.L, t.N, t.Y, J(t));
        return !1;
    }
    if (o === t.D) {} else {
        const s = o.parent;
        t.Y = o;
        $o(t.Y, Oe, e);
        n && $o(n, e, t.Y);
        Ao(t.L, t.Y);
        Po(t.L, t.N, t.Y, J(t));
        s && so(s) && !s.firstChild && Fo(s) === Je && Mo(t.L, s.parent, s, !0);
    }
    return !0;
}

function Y(t) {
    if (t.K) {
        for (const n of t.K.values()) {
            if (n.flags & 32) {
                continue;
            }
            St(t.O, t.L, n, t.U);
            Mo(t.L, t.N, n, !0);
        }
        t.K.clear();
        t.K = null;
    }
    t.D = null;
}

function G(t) {
    for (;t.B.length; ) {
        const n = t.B.shift();
        const e = t.B.shift();
        if (hr(n)) {
            return n.then(n => {
                D(t, n, e);
                return G(t);
            }).catch(n => {
                t.O.handleError(n, e);
                return G(t);
            });
        }
        D(t, n, e);
    }
    if (t.H.length) {
        const n = t.H.splice(0);
        return Promise.all(n).then(() => G(t));
    }
}

function X(t) {
    t.L = null;
    t.U = null;
}

function K(t, n = !0) {
    const e = t.D && Lo(t.D);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            St(t.O, t.L, s, t.U);
            s = s.nextSibling;
        }
        To(t.L, t.D, e, n);
    }
}

function Z(t) {
    const n = P(t);
    if (t.D !== null && t.D !== n) {
        for (;t.D && t.D !== n; ) {
            const n = t.D;
            t.D = N(t, t.D);
            if (t.N === n.parent) {
                St(t.O, t.L, n, t.U);
                Mo(t.L, t.N, n, !0);
            }
        }
    }
}

function tt(t) {
    if (t.D !== null && co(t.D)) {
        const n = t.D;
        t.D = N(t, t.D);
        Mo(t.L, t.N, n, !0);
    }
}

function nt(t, n, e) {
    if (zu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw ge(15, [ e ]);
}

function et(t, e, s, o, r) {
    return n(() => kl(o, e, s, t, r));
}

function rt(t, n, e, s, o) {
    const i = t.W;
    const c = s.then(t => E(n, e, r(e, t, i), o));
    t.H.push(c);
}

function it(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Qe, "html");
    }
}

function st(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function ot(t, n, e, o) {
    const i = function c(t, n) {
        const e = No(t.N, !0);
        const o = s(e, n);
        const r = import.meta.env.TEST ? t.O.document : document;
        const i = o.elementNamespaceFlag === 0 ? r.createElement(n) : r.createElementNS(o.elementNamespace, n);
        t.Y = to(i, n);
        t.Y.flags |= o.elementNamespaceFlag;
        return i;
    }(t, e);
    const l = t.Y;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let s = f[n];
            if (wr(n)) {
                lt(n, s, i, l, t);
                continue;
            }
            if (n === "ref" && nt(s, i, o)) {
                continue;
            }
            zu(s) && (s = et(t.O, t.Y, n, s, t.st.ot));
            if (hr(s)) {
                rt(t, i, n, s, u);
                continue;
            }
            if (n === cr) {
                it(i, s);
                continue;
            }
            if (e === "textarea" && n === "value" && st(i, s)) {
                continue;
            }
            E(i, n, r(n, s, t.W), u);
        }
    }
    const a = n.key;
    a && (t.Y.key = a);
    if (t.W) {
        const e = zs.call(n.varProps, "class") || n.constProps && zs.call(n.constProps, "class");
        e || i.setAttribute("class", t.W);
    }
    Co(t.L, t.N, t.Y, I(t));
}

function lt(t, n, e, s, o) {
    const r = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(_.bind(null, n));
                }
            } else {
                e && s.push(_.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[r] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[r] = _.bind(null, n));
    }
    t.charAt(2) !== "e" && po(o.L, s, t, "");
    (function i(t, n) {
        const e = import.meta.env.TEST ? t.O.document.defaultView : window;
        e && (e._qwikEv ||= []).push(n);
    })(o, r);
}

function ut(t, n, e) {
    if (t.it) {
        ot(t, n, e, null);
    } else {
        const s = t.D && so(t.D);
        const o = s && e === Fo(t.D);
        const r = n.key;
        const i = s && t.D.key;
        if (o && r === i) {
            ft(t, e, r);
        } else {
            const s = ct(e, r);
            at(t, e, r, s, t.N) && ot(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.Y || t.D;
    s && function r(t, n, e, s) {
        t.it || mo(t.O, n);
        const o = n.props;
        for (const r in e) {
            const i = e[r];
            if (o && zs.call(o, r)) {
                const e = o[r];
                if (i !== e) {
                    if (i instanceof Gi && e instanceof Gi && qt(i, e)) {
                        continue;
                    }
                    Us(t, n, r, i, s);
                }
            } else {
                i != null && Us(t, n, r, i, s);
            }
        }
        if (o) {
            for (const r in o) {
                zs.call(e, r) || r.charAt(0) === ":" || wr(r) || Us(t, n, r, null, s);
            }
        }
    }(t, o, s, null);
}

const Us = (t, n, e, s, o) => {
    if (wr(e)) {
        lt(e, s, n.node, n, t);
        return;
    }
    if (e === er || e === rr) {
        $o(n, e, s);
        n.flags |= 192;
        return;
    }
    const r = s;
    if (e === "ref") {
        const t = n.node;
        if (nt(s, t, o)) {
            return;
        }
    }
    const i = n[Xr]?.get(e);
    if (zu(s)) {
        const o = s instanceof Gi ? s.ct() : s;
        if (i?.backRef?.has(o)) {
            return;
        }
        i && y(t.O, i);
        const r = n;
        s = et(t.O, r, e, o, t.st.ut);
    } else {
        i && y(t.O, i);
    }
    if (hr(s)) {
        const o = n;
        const i = s.then(n => {
            M(t.L, o, e, n, t.W, r);
        });
        t.H.push(i);
        return;
    }
    M(t.L, n, e, s, t.W, r);
};

function ct(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function ft(t, n, e) {
    const s = ct(n, e);
    if (s && t.K?.has(s)) {
        t.K.delete(s);
        return !0;
    }
    return !1;
}

function at(t, n, e, s, o, r) {
    t.Y = function i(t, n, e) {
        let s = null;
        if (t.G === null) {
            const o = t.D;
            if (o) {
                const s = so(o) ? Fo(o) : null;
                const r = mt(o) || wt(o, t.O._);
                if (r === e && s === n) {
                    return o;
                }
            }
            t.G = new Map;
            t.X = [];
            const r = P(t);
            let i = t.D;
            for (;i && i !== r; ) {
                const o = so(i) ? Fo(i) : null;
                const r = mt(i) || wt(i, t.O._);
                s === null && r == e && o == n ? s = i : r === null ? t.X.push(o, i) : t.G.set(ct(o, r), i);
                i = i.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.X.length; e += 2) {
                if (t.X[e] === n) {
                    s = t.X[e + 1];
                    t.X.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ct(n, e);
            const r = t.G.get(o);
            if (r) {
                s = r;
                t.G.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.D) {
                    const n = so(t.D) ? Fo(t.D) : null;
                    const e = mt(t.D) || wt(t.D, t.O._);
                    if (e != null) {
                        const s = ct(n, e);
                        t.K ||= new Map;
                        t.K.set(s, t.D);
                        t.G?.delete(s);
                    }
                }
                return;
            }
            const e = P(t);
            let s = t.D;
            for (;s && s !== n && s !== e; ) {
                const n = so(s) ? Fo(s) : null;
                const e = mt(s) || wt(s, t.O._);
                if (e != null) {
                    const o = ct(n, e);
                    t.K ||= new Map;
                    t.K.set(o, s);
                    t.G?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.Y) {
        s || Po(t.L, o, t.Y, I(t));
        t.D = t.Y;
        t.Y = null;
        return !1;
    }
    if (s != null) {
        const n = t.K?.get(s) || null;
        if (n) {
            t.K.delete(s);
            if (r && t.D) {
                const n = mt(t.D) || wt(t.D, t.O._);
                if (n != null) {
                    const e = so(t.D) ? Fo(t.D) : null;
                    const s = ct(e, n);
                    if (s != null) {
                        t.K ||= new Map;
                        t.K.set(s, t.D);
                    }
                }
            }
            n !== t.D && Po(t.L, o, n, I(t));
            t.D = n;
            t.Y = null;
            return !1;
        }
    }
    return !0;
}

function ht(t, n, e) {
    const s = n === "F";
    const o = mt(t.D);
    const r = t.D && fo(t.D);
    const i = r && o === e && (!s || !!e);
    if (i) {
        ft(t, null, o);
        return;
    }
    if (e === null || t.it) {
        jo(t.L, t.N, t.Y = ro(), J(t));
        t.Y.key = e;
        return;
    }
    if (at(t, null, e, ct(null, e), t.N, !0)) {
        jo(t.L, t.N, t.Y = ro(), J(t));
        t.Y.key = e;
    }
}

function dt(t, n) {
    const e = n[Wc];
    let s = t.Y || t.D;
    const o = t.tt;
    if (e) {
        const n = o.props;
        let r = !1;
        const [i] = e;
        const c = i.ft;
        const l = wt(s, t.O._);
        const u = o.key || c;
        const f = mt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                ft(t, null, u);
            } else {
                $t(t, s, i, n);
                s = t.Y;
                r = !0;
            }
        } else {
            if (at(t, null, u, u, t.N)) {
                $t(t, s, i, n);
                r = !0;
            }
            s = t.Y || t.D;
        }
        if (s) {
            const e = ho(s, Ze, t.O._);
            if (!r) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = vt(n[fi], e[fi], e[di], s, !1);
                        o ||= t;
                        const r = vt(n[ai], e[ai], e[di], s, !0);
                        o ||= r;
                        e[hi] = n[hi];
                    } else if (n) {
                        $o(t, Ze, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.O);
                if (c && o.key == null) {
                    $t(t, s, i, n);
                    s = t.Y;
                    r = !0;
                }
                r ||= c;
            }
            if (r) {
                $o(s, Ce, i);
                s.flags &= -33;
                nn(t.O, s, 4, t.U);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new ts(bt, null, null, [], 0, t);
            const r = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (O(n)) {
                            const t = n;
                            de(r, t, o(t), 0);
                        }
                    }
                }
            }
            if (r.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (es(n) && gi(n, Oe) || "") + "";
                const i = he(r, e, 0);
                let c;
                i >= 0 ? c = r[i + 1] : r.splice(~i, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = r.length - 2; t >= 0; t -= 2) {
                r.splice(t, 1);
            }
            W(t, r, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const r = mt(s);
        const i = e === r;
        const c = wt(s, t.O._);
        const l = c == null;
        if (s && !l || !s) {
            pt(t);
            s = t.Y;
        } else if (i) {
            ft(t, null, e);
        } else {
            at(t, null, e, e, t.N) && pt(t);
            s = t.Y || t.D;
        }
        if (s) {
            let e = s;
            for (;e && (!fo(e) || ho(e, Ce, null) === null); ) {
                e = e.parent || $l(e);
            }
            const r = ms(t.O, s, e || t.O.rootVNode, n, o.props);
            t.B.push(r, s);
        }
    }
}

function $t(t, n, e, s) {
    n && p(t.O, n);
    jo(t.L, t.N, t.Y = ro(), J(t));
    const o = t.tt;
    $o(t.Y, Ce, e);
    $o(t.Y, Ze, s);
    t.Y.key = o.key;
}

function pt(t) {
    jo(t.L, t.N, t.Y = ro(), J(t));
    const n = t.tt;
    $o(t.Y, Ze, n.props);
    n.key && (t.Y.key = n.key);
}

function yt(t, n) {
    if (t.D !== null) {
        const e = hl(t.D);
        if (e === 3) {
            if (n !== zo(t.D)) {
                Do(t.L, t.D, n);
                return;
            }
            return;
        }
    }
    Co(t.L, t.N, t.Y = eo((import.meta.env.TEST ? t.O.document : document).createTextNode(n), n), I(t));
}

function mt(t) {
    if (t == null || co(t)) {
        return null;
    }
    return t.key;
}

function wt(t, n) {
    if (t == null || co(t)) {
        return null;
    }
    const e = ho(t, Ce, n);
    return e ? e.ft : null;
}

function bt() {}

function vt(t, n, e, s, o = !0) {
    if (gt(t) && gt(n)) {
        return !1;
    }
    e.O = s;
    let r = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === Te) {
                continue;
            }
            if (!n || t[s] !== n[s]) {
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = t[s]);
                    const o = vi(e, s);
                    o || (r = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === Te) {
                continue;
            }
            if ((!t || !zs.call(t, s)) && o) {
                delete n[s];
                const t = vi(e, s);
                t || (r = !0);
            }
        }
    }
    return r;
}

function gt(t) {
    if (!t) {
        return !0;
    }
    return Tr(t);
}

function St(t, n, e, s = null) {
    let o = e;
    if (co(e)) {
        xt(o);
        return;
    }
    let r = null;
    for (;;) {
        const i = o.flags;
        if (i & 3) {
            p(t, o);
            xt(o);
            const r = i & 2 && ho(o, Ce, null) !== null;
            if (r) {
                const e = t.getHostProp(o, tr);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const r = e[n];
                        if (me(r)) {
                            const n = Tu(r);
                            if (n && r.R & 1) {
                                r.R |= 16;
                                nn(t, o, 64, s);
                                continue;
                            }
                            (r instanceof ci || Zu(r)) && p(t, r);
                            (n || r instanceof Ii) && Fs(r);
                        }
                    }
                }
                const r = o.props;
                if (r) {
                    for (const e of Object.keys(r)) {
                        if (O(e)) {
                            const o = r[e];
                            if (o) {
                                r[e] = null;
                                const i = typeof o === "string" ? go(t.rootVNode, o) : o;
                                let c = Lo(i);
                                for (;c; ) {
                                    St(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                kt(n, i);
                            }
                        }
                    }
                }
            }
            const c = ao(o);
            if (c) {
                if (o === e) {
                    const t = Lo(o);
                    if (t) {
                        on(t, () => {});
                        return;
                    }
                }
            } else {
                const t = Lo(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            i & 4 && xt(o);
        }
        if (o === e) {
            return;
        }
        const c = o.nextSibling;
        if (c) {
            o = c;
            continue;
        }
        r = o.parent;
        for (;r; ) {
            if (r === e) {
                return;
            }
            const t = r.nextSibling;
            if (t) {
                o = t;
                break;
            }
            r = r.parent;
        }
        if (r == null) {
            return;
        }
    }
}

function kt(t, n) {
    const e = n.parent;
    if (e) {
        const s = e.flags;
        s & 1 && Fo(e) === Je && Mo(t, e, n, !0);
    }
}

function xt(t) {
    t.flags |= 32;
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ht === t.ht && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.dt, t.dt);
}

function Rt(t, n) {
    if (!(n instanceof Gi)) {
        return !1;
    }
    for (const e of t) {
        if (e instanceof Gi && qt(e, n)) {
            return !0;
        }
    }
    return !1;
}

function Ct(t) {
    return !!t && lo(t) && t.key != null;
}

function jt(t) {
    for (;t; ) {
        if (Ct(t)) {
            return t;
        }
        t = t.nextSibling;
    }
    return null;
}

function Et(t) {
    for (;t; ) {
        if (Ct(t)) {
            return t;
        }
        t = t.previousSibling;
    }
    return null;
}

function Ot(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function _t(t, n, e, s, o, r, i, c, l, u, f = null) {
    const a = u - l;
    if (a <= 0) {
        return;
    }
    let h = 0;
    const d = () => {
        for (;h < a; ) {
            const u = l + h;
            const a = Ls(t, n, Ot(r[u], u, i(r[u], u), c), e, null, f, s, null, !0, o);
            h++;
            if (hr(a)) {
                return a.then(d);
            }
        }
    };
    return d();
}

function At(t, n, e, s, o, r, i) {
    const c = t;
    const l = T(c, n, s, null);
    const u = o.length;
    const f = Lo(e);
    if (f === null) {
        if (u > 0) {
            return _t(c, n, e, s, l, o, r, i, 0, u);
        }
        return;
    }
    if (u === 0) {
        To(n, e, f, !0);
        return;
    }
    const a = Array(u);
    for (let t = 0; t < u; t++) {
        a[t] = r(o[t], t);
    }
    const h = (t, n) => a[n];
    let d = jt(f);
    if (d === null) {
        return _t(c, n, e, s, l, o, h, i, 0, u);
    }
    let $ = Et(e.lastChild);
    let p = null;
    let y = 0;
    for (;d && y < u && d.key === a[y]; ) {
        const t = d;
        y++;
        if (t === $) {
            d = null;
            $ = null;
            break;
        }
        d = jt(t.nextSibling);
    }
    let m = u - 1;
    for (;$ && m >= y && $.key === a[m]; ) {
        const t = $;
        p = t;
        m--;
        if (t === d) {
            d = null;
            $ = null;
            break;
        }
        $ = Et(t.previousSibling);
    }
    if (d === null && y > m) {
        return;
    }
    if (d === null) {
        return _t(c, n, e, s, l, o, h, i, y, m + 1, p);
    }
    if (y > m) {
        if (y === 0 && p === null) {
            To(n, e, d, !0);
        } else {
            let t = d;
            for (;t; ) {
                const s = t;
                t = s === $ ? null : jt(s.nextSibling);
                Mo(n, e, s, !0);
            }
        }
        return;
    }
    const w = function b(t, n) {
        const e = [];
        let s = t;
        for (;s; ) {
            Ct(s) && e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(d, $);
    const g = w.length;
    const v = new Map;
    for (let t = 0; t < g; t++) {
        v.set(w[t].key, t);
    }
    let S = 0;
    let k = -1;
    let x = !0;
    const q = new Int32Array(m - y + 1);
    q.fill(-1);
    for (let t = y; t <= m; t++) {
        const n = v.get(a[t]);
        if (n !== void 0) {
            S++;
            q[t - y] = n;
            n <= k ? x = !1 : k = n;
        }
    }
    if (S === 0) {
        if (y === 0 && p === null) {
            To(n, e, d, !0);
            return _t(c, n, e, s, l, o, h, i, 0, u);
        }
        for (let t = 0; t < g; t++) {
            Mo(n, e, w[t], !0);
        }
        return _t(c, n, e, s, l, o, h, i, y, m + 1, p);
    }
    const R = x ? function C(t) {
        const n = new Uint8Array(t.length);
        for (let e = 0; e < t.length; e++) {
            t[e] >= 0 && (n[e] = 1);
        }
        return n;
    }(q) : function j(t) {
        const n = new Int32Array(t.length);
        n.fill(-1);
        const e = new Int32Array(t.length);
        let s = 0;
        for (let o = 0; o < t.length; o++) {
            const r = t[o];
            if (r < 0) {
                continue;
            }
            let i = 0;
            let c = s;
            for (;i < c; ) {
                const n = i + c >> 1;
                const s = e[n];
                t[s] < r ? i = n + 1 : c = n;
            }
            i > 0 && (n[o] = e[i - 1]);
            e[i] = o;
            i === s && s++;
        }
        const o = new Uint8Array(t.length);
        let r = s > 0 ? e[s - 1] : -1;
        for (;r !== -1; ) {
            o[r] = 1;
            r = n[r];
        }
        return o;
    }(q);
    let _ = p;
    let E = m;
    const O = () => {
        const t = (_ ? _.previousSibling : e.lastChild) || null;
        t && (_ = t);
    };
    const A = () => {
        for (;E >= y; ) {
            const t = o[E];
            const r = a[E];
            const u = v.get(r);
            if (u !== void 0) {
                const t = w[u];
                v.delete(r);
                R[E - y] === 0 && Po(n, e, t, _);
                _ = t;
                E--;
                continue;
            }
            const f = Ls(c, n, Ot(t, E, r, i), e, null, _, s, null, !1, l);
            return $r(f, () => {
                O();
                E--;
                return A();
            });
        }
        for (const t of v.values()) {
            Mo(n, e, w[t], !0);
        }
    };
    return A();
}

function Pt(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, tr);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (const r of s) {
        if (r instanceof Mu) {
            const s = r;
            if (!(s.R & 4)) {
                continue;
            }
            if (s.R & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const r = !!(s.R & 8);
                const i = Nu(s, n, t);
                hr(i) && (r ? o = o ? o.then(() => i) : i : (e.extraPromises ||= []).push(i));
            }
        }
    }
    return o;
}

function It(t, n) {
    const e = t.props ||= {};
    e[li] = n;
}

function Nt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let r = function i(t) {
        const n = t.props;
        return n?.[li];
    }(t);
    if (!r) {
        return;
    }
    It(t, null);
    zu(r) && (r = r.value);
    return Ds(n, e, r, o, s, null);
}

function Mt(t, e, s, o) {
    t.dirty &= -5;
    const r = t;
    const i = e.getHostProp(r, Ce);
    if (!i) {
        return;
    }
    const c = e.getHostProp(r, Ze) || null;
    const l = dr(() => ms(e, r, r, i, c), t => {
        const i = e.getHostProp(r, Ne);
        return n(() => Ds(e, s, t, r, o, mr(i)));
    }, t => {
        e.handleError(t, r);
    });
    if (hr(l)) {
        return l;
    }
    return;
}

function Tt(t, n, e, s, o, r = null) {
    n.push(Ts(t.node, e, s, r, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Ft(t, n) {
    t.dirty &= -9;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[oi] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        zu(e) && (e = e.value);
        const r = s.isConst;
        Tt(o, n, t, e, r, s.scopedStyleIdPrefix);
    }
    (function r(t) {
        const n = t.props ||= {};
        delete n[oi];
    })(t);
}

function zt(t, n) {
    t.dirty &= -65;
    const e = n.getHostProp(t, tr);
    if (!e || e.length === 0) {
        return;
    }
    for (const t of e) {
        if (t instanceof Mu && t.R & 16) {
            t.R &= -17;
            const n = t;
            Fs(n);
        }
    }
}

function Dt(t, e) {
    t.dirty &= -17;
    const s = e.getHostProp(t, ui);
    if (!s) {
        return;
    }
    const o = s.$;
    const r = yn();
    r.O = e;
    return $r(n(() => dn.call(s, r, s.j)), () => {
        if (s.R & 2) {
            s.R &= -3;
            return Wu(e, s, o);
        }
    });
}

function Lt(t, n, e, s) {
    t.dirty &= -129;
    const o = t;
    const r = n.getHostProp(o, Ze) || null;
    if (!r) {
        return;
    }
    let i = Si(r, "items");
    zu(i) && (i = vl(i));
    const c = Si(r, "key$");
    const l = Si(r, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return At(n, e, o, s, i, u, f);
    }
    return $r(c.resolve(), t => $r(l.resolve(), r => At(n, e, o, s, i, t, r)));
}

let Ws = null;

const Qs = (t, n, e) => {
    Ws || (Ws = t.insertBefore);
    Ws.call(t, n, e);
};

function Ut(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const i = () => {
        if (s) {
            if (s.length === 1) {
                Qs(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                Qs(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof _s) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                i();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            Qs(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof js) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            l.target.remove();
            continue;
        }
        if (l instanceof Es) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && i();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof Os) {
            l.target.nodeValue = l.text;
        } else if (l instanceof As) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? r(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if (Vs(t, e)) {
                t[e] = Js(o);
            } else if (e === cr) {
                n === t && i();
                t.innerHTML = o;
                t.setAttribute(Qe, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : E(t, e, o, l.isSvg);
            }
        }
    }
    i();
}

const Vs = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const Js = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const Bs = (t => () => queueMicrotask(t))(Vt);

const Ys = (t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        e.port1.onmessage = () => t();
        n = () => e.port2.postMessage(null);
    } else {
        n = () => setTimeout(t);
    }
    return n;
})(Vt);

let Gs = !1;

function Wt() {
    if (!Gs) {
        Gs = !0;
        Bs();
    }
}

function Qt() {
    if (!Gs) {
        Gs = !0;
        Ys();
    }
}

function Vt(t = {
    timeBudget: 1e3 / 60
}) {
    Gs = !1;
    let n = null;
    for (;n = l(); ) {
        Jt(n, t);
    }
}

function Jt(t, n) {
    const {timeBudget: e} = n;
    const s = import.meta.env.TEST ? Vr() : Kn;
    const o = performance.now();
    const r = h(t);
    const i = r.promise;
    if (i) {
        return;
    }
    const l = r.container;
    if (!t.dirty) {
        Bt(l, t, r, s);
        return;
    }
    const f = r.journal ||= [];
    let d = null;
    for (;d = r.position; ) {
        if (r.promise) {
            return;
        }
        if (!(d.dirty & 255)) {
            a(l, r, Gt(d, t));
            continue;
        }
        if (d.flags & 32) {
            if (d.dirty & 64) {
                zt(d, l);
            } else if (d.dirty & 32) {
                const n = Yt(l, r, d, t);
                if (n !== null) {
                    d = n;
                    continue;
                }
            }
            d.dirty &= -256;
            a(l, r, Gt(d, t));
            continue;
        }
        let n;
        try {
            if (d.dirty & 1) {
                n = Pt(d, l, r);
            } else if (d.dirty & 2) {
                n = Nt(d, l, f, t);
            } else if (d.dirty & 4) {
                n = Mt(d, l, f, t);
            } else if (d.dirty & 128) {
                n = Lt(d, l, f, t);
            } else if (d.dirty & 8) {
                Ft(d, f);
            } else if (d.dirty & 16) {
                n = Dt(d, l);
            } else if (d.dirty & 32) {
                const n = Yt(l, r, d, t);
                if (n !== null) {
                    d = n;
                    continue;
                }
            }
        } catch (t) {
            l.handleError(t, d);
        }
        if (n && hr(n)) {
            r.promise = n;
            u(t, l);
            const e = d;
            n.catch(t => {
                l.handleError(t, e);
            }).finally(() => {
                r.promise = null;
                c(t, l);
                Wt();
            });
            return;
        }
        if (Zn) {
            const t = performance.now() - o;
            if (t >= e) {
                Qt();
                return;
            }
        }
    }
    Bt(l, t, r, s);
}

function Bt(t, n, e, s) {
    if (!(n.dirty & 255)) {
        f(n, t);
        s || function o(t, n) {
            const e = h(t);
            const s = e.journal;
            if (s && s.length > 0) {
                Ut(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                let s;
                for (const n of e) {
                    const e = n;
                    const o = Nu(e, t, e.$t);
                    hr(o) && (s = s ? s.then(() => o) : o);
                }
                s && (n.extraPromises ||= []).push(s);
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                Ht(t);
            });
            return;
        }
        Ht(t);
    }
}

function Ht(t) {
    t.yt();
}

function Yt(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -33;
        return null;
    }
    (function r(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const i = Gt(o[0], s);
    a(t, n, i);
    return i;
}

function Gt(t, n) {
    if (t === n) {
        if (n.dirty & 255) {
            return n;
        }
        return null;
    }
    let e = null;
    t.slotParent && t.slotParent.dirty & 32 ? e = t.slotParent : t.parent && t.parent.dirty & 32 && (e = t.parent);
    if (!e) {
        if (n.dirty & 255) {
            return n;
        }
        return null;
    }
    const s = e.dirtyChildren;
    let o = e.nextDirtyChildIndex;
    const r = s.length;
    let i = r;
    for (;i-- > 0; ) {
        const t = s[o];
        if (t.dirty & 255) {
            e.nextDirtyChildIndex = (o + 1) % r;
            return t;
        }
        o++;
        o === r && (o = 0);
    }
    e.dirty &= -33;
    e.dirtyChildren = null;
    e.nextDirtyChildIndex = 0;
    return Gt(e, n);
}

function Xt(t, n, e) {
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null
    };
    (function r(t, n) {
        si.set(t, n);
    })(n, s);
    const i = n;
    i.flags |= 256;
    o(t, i);
    Wt();
    return i;
}

function Kt(t) {
    return (t.flags & 256) !== 0;
}

function Zt(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 8 && function e(t, n) {
            n.dirty &= -9;
            const e = n.getProp(oi);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                zu(e) && (e = e.value);
                const i = r(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, i);
            }
        }(t, n);
        n.dirty & 16 && Dt(n, t);
        if (n.dirty & 255) {
            const t = `A chore was scheduled on a host element that has already been streamed to the client.\n        This can lead to inconsistencies between Server-Side Rendering (SSR) and Client-Side Rendering (CSR).\n        \n        Problematic chore:\n          - Host: ${"" + n}\n          - Nearest element location: ${n.currentFile}\n        \n        This is often caused by modifying a signal in an already rendered component during SSR.`;
            fe(t);
        }
        n.dirty &= -256;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(tr);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (const o of e) {
                if (o instanceof Mu) {
                    const e = o;
                    if (!(e.R & 4)) {
                        continue;
                    }
                    const r = Nu(e, t, n);
                    s = s ? s.then(() => r) : r;
                }
            }
            return s;
        }(t, n);
        hr(s) && (e = s);
    }
    if (n.dirty & 128) {
        const s = async function o(t, n) {
            n.dirty &= -129;
            const e = n;
            const s = t.getHostProp(e, Ze) || null;
            if (!s) {
                return;
            }
            let o = Si(s, "items");
            zu(o) && (o = vl(o));
            const r = await Si(s, "key$").resolve();
            const i = await Si(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = i(n, t);
                const s = r(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -252;
    if (e) {
        return e;
    }
}

const Xs = [];

function tn(t) {
    for (let n = 0; n < Xs.length; n++) {
        const e = Xs[n];
        const s = Xs[n + 1] || t;
        s.dirty |= 32;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function nn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function r() {
        return import.meta.env.TEST ? Vr() : Kn;
    }()) {
        const e = Zt(t, n);
        hr(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return;
    }
    const i = e & 255;
    if ((i ? o & 255 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && i && c && !c.dirty) {
        (function t(n, e) {
            Xs.push(n);
            let s = n.slotParent || n.parent;
            for (;s; ) {
                const t = s.dirty & 255;
                const o = Kt(s);
                if (s === e || t) {
                    tn(s);
                    if (o) {
                        const t = h(s);
                        t.position !== s && (t.position = n);
                    }
                    Xs.length = 0;
                    return;
                }
                if (o) {
                    const t = h(s);
                    t.position !== s && (t.position = n);
                }
                Xs.push(s);
                s = s.slotParent || s.parent;
            }
            Xs.length = 0;
            ((t, ...n) => {
                const e = ae(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(n, s);
        return;
    }
    if (c && c.dirty & 255) {
        i && (c.dirty |= 32);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (i && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (Kt(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = h(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        Kt(n) || function l(t) {
            Xs.push(t);
            let n = t.slotParent || t.parent;
            for (;n; ) {
                const t = Kt(n);
                if (t) {
                    tn(n);
                    Xs.length = 0;
                    return !0;
                }
                Xs.push(n);
                n = n.slotParent || n.parent;
            }
            Xs.length = 0;
            return !1;
        }(n) || Xt(t, n, 0);
    }
}

function en(t, n) {
    t.push(n);
}

const Ks = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const Zs = t => {
    let n = null;
    return e => {
        n || (n = Ks(e, t));
        return n.call(e);
    };
};

const to = (t, n, e = null) => {
    const s = new ni(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const no = t => {
    const n = new ni(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const eo = (t, n) => {
    const e = new ei(-4084, null, null, null, null, t, n);
    return e;
};

const ro = () => {
    const t = new ti(null, -4094, null, null, null, null, null, null);
    return t;
};

const io = t => t instanceof Zr;

const so = t => (t.flags & 1) === 1;

const oo = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const lo = t => {
    const n = t.flags;
    return (n & 3) !== 0;
};

const uo = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const co = t => (t.flags & 4) === 4;

const fo = t => (t.flags & 2) === 2;

const ao = t => {
    const n = t.flags;
    return (n & 2) === 2 && ho(t, Oe, null) !== null;
};

const ma = t => t;

const ho = (t, n, e) => {
    if (so(t) || fo(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const $o = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const po = (t, n, e, s, o = null) => {
    if (so(n)) {
        import.meta.env.TEST && o && $o(n, fr, o);
        $o(n, e, s);
        en(t, Ts(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const yo = t => {
    if (t.key) {
        return;
    }
    const n = Jo(t.node, ur);
    n && (t.key = n);
};

const mo = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let r = !1;
        for (let n = 0; n < o.length; n++) {
            const i = o[n];
            const c = i.name;
            if (wr(c)) {
                rn(i, c, t, s);
                continue;
            }
            if (r) {} else if (c !== ur && c) {
                if (c.startsWith(Qe)) {
                    const t = i.value;
                    t === "html" ? $o(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && $o(e, "value", s.value);
                } else {
                    const t = i.value;
                    $o(e, c, t);
                }
            } else {
                const t = i.value;
                t && (e.key = t);
                r = !0;
            }
        }
        ho(e, er, null) === null && ho(e, rr, null) === null || (n.flags |= 64);
    }
};

const wo = t => {
    if (t.St === "_run") {
        const n = t.getCaptured()?.[0];
        if (ke(n)) {
            return n;
        }
    }
    return t;
};

function rn(t, n, e, s) {
    const o = t.value;
    const r = n.slice(2);
    const i = o.split("|");
    const c = [];
    for (let t = 0; t < i.length; t++) {
        const n = wo(bn(i[t], e));
        c.push(_.bind(null, n));
    }
    (s._qDispatch ||= {})[r] = c.length === 1 ? c[0] : c;
}

function sn(t, n, e) {
    let s = Lo(n);
    for (;s; ) {
        if (co(s)) {
            vo(t, s);
            e(s, n);
        } else {
            so(s) ? e(s, n) : sn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function on(t, n) {
    let e = t;
    if (co(t)) {
        n?.(t, null);
        return;
    }
    let s = null;
    for (;;) {
        if (n?.(e, s)) {
            return;
        }
        const o = Lo(e);
        if (o) {
            e = o;
            continue;
        }
        if (e === t) {
            return;
        }
        const r = e.nextSibling;
        if (r) {
            e = r;
            continue;
        }
        s = e.parent;
        for (;s; ) {
            if (s === t) {
                return;
            }
            const n = s.nextSibling;
            if (n) {
                e = n;
                break;
            }
            s = s.parent;
        }
        if (s == null) {
            return;
        }
    }
}

const bo = (t, n, e) => {
    let s = t;
    for (;e && s && fo(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !fo(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !fo(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (co(t) && e && so(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && ul(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const vo = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Io(n, !0);
        const o = e.node;
        const r = el(s);
        let i = bo(n, !1, !0);
        const c = bo(n, !0, !0);
        const l = o || (c && so(c) ? c.node : c?.node) || null;
        let u = l;
        for (;i && co(i); ) {
            if ((i.flags & 8) === 0) {
                const n = r.createTextNode(i.text);
                en(t, Ms(n, s, u));
                u = n;
                i.node = n;
                i.flags |= 8;
            }
            i = bo(i, !1, !0);
        }
        i = n;
        for (;i && co(i); ) {
            const n = bo(i, !0, !0);
            const e = !n || !co(n);
            if ((i.flags & 8) === 0) {
                if (e && o) {
                    en(t, Ns(o, i.text));
                } else {
                    const n = r.createTextNode(i.text);
                    en(t, Ms(n, s, l));
                    i.node = n;
                }
                i.flags |= 8;
            }
            i = n;
        }
    }
};

const go = (t, n) => {
    let e = t;
    const s = t.node;
    const {qVNodeRefs: o} = s;
    let r = -1;
    let i;
    if (typeof n === "string") {
        r = parseInt(n);
        i = o.get(r);
    } else {
        i = n;
        const t = i.vNode;
        if (t) {
            return t;
        }
    }
    if (io(i)) {
        e = i;
    } else {
        let t = i;
        const n = [ i ];
        for (;t && t !== s && !t.vNode; ) {
            t = t.parentElement;
            n.push(t);
        }
        t.vNode && (e = t.vNode);
        for (let t = n.length - 2; t >= 0; t--) {
            e = xo(e, n[t]);
        }
        if (r != -1) {
            i.vNode = e;
            o.set(r, e);
        }
    }
    if (typeof n === "string") {
        const t = n.length;
        let s = qo(n, t);
        let o = 0;
        for (;s < t; ) {
            const t = n.charCodeAt(s);
            o *= 26;
            if (t >= 97) {
                o += t - 97;
            } else {
                o += t - 65;
                e = So(e, o);
                o = 0;
            }
            s++;
        }
    }
    return e;
};

const So = (t, n) => {
    let e = Lo(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const ko = [];

const xo = (t, n) => {
    let e = Lo(t);
    for (;e && (!(e instanceof ni) || e.node !== n); ) {
        if (fo(e)) {
            const t = e.nextSibling;
            const n = Lo(e);
            if (n) {
                t && ko.push(t);
                e = n;
            } else {
                e = t || (ko.length ? ko.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || ko.pop();
        }
    }
    for (;ko.length; ) {
        ko.pop();
    }
    return e;
};

const qo = (t, n) => {
    let e = 0;
    for (;e < n; ) {
        if (!(t.charCodeAt(e) <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Ro = Ut;

const Co = (t, n, e, s) => {
    const o = so(n);
    o && Uo(n);
    const r = e.parent;
    if (e === s) {
        if (r) {
            return;
        }
        s = null;
    }
    _o(t, r, n, e);
    const i = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Io(n, !1);
    l && !c && en(t, Ms(i, l, Eo(t, n, s)?.node ?? null));
    Oo(n, e, s);
    c && (e.flags |= 32);
};

const jo = (t, n, e, o) => {
    const r = so(n);
    r && Uo(n);
    const c = e.parent;
    if (e === o) {
        if (c) {
            return;
        }
        o = null;
    }
    _o(t, c, n, e);
    const l = n.flags & 32;
    const u = !r && n.flags & 2048 ? n.props?.[je] : null;
    const f = u ? null : r ? n : No(n, !1);
    const a = u || f?.node;
    const h = Eo(t, n, o);
    const d = h?.node ?? null;
    const $ = ao(e);
    if ($ && f && (f.flags & 1536) !== 0) {
        const r = No(n, !1);
        const c = Eo(t, n, o)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = s(r, e);
        sn(t, e, n => {
            if (co(n)) {
                en(t, Ms(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, o, r) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (so(c)) {
                                e = c.node;
                                const t = Fo(c);
                                const l = c.parent;
                                const h = u == null ? n : l && No(l, !0);
                                if (h) {
                                    const t = s(h, Fo(c));
                                    o = t.elementNamespace;
                                    r = t.elementNamespaceFlag;
                                }
                                const d = Lo(c);
                                a = i(e, t, o, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= r;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (Qo(e)) {
                                    const t = Fn(e);
                                    if (t) {
                                        const n = Lo(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, r, l, u);
                    t && (n.node = t);
                }
                en(t, Ms(n.node, a, c));
            }
        });
    } else {
        a && !l && sn(t, e, n => {
            en(t, Ms(n.node, a, d));
        });
    }
    Oo(n, e, o);
    l && (e.flags |= 32);
};

const Eo = (t, n, e) => {
    let s = null;
    e == null ? fo(n) && (s = bo(n, !0, !1)) : s = fo(e) ? bo(e, !0, !0) : e;
    s && co(s) && vo(t, s);
    return s;
};

const Oo = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const _o = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && Mo(t, n, s, !1);
};

const Ao = (t, n) => {
    let e = n;
    for (;e && fo(e); ) {
        e = e.lastChild;
    }
    e && co(e) && (e.flags & 8) === 0 && vo(t, e);
};

const Po = (t, n, e, s) => {
    oo(e) ? Co(t, n, e, s) : jo(t, n, e, s);
};

const Io = (t, n) => {
    for (;t && !so(t); ) {
        if (t.flags & 2048) {
            return t.props?.[je];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const No = (t, n) => {
    for (;t && !so(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const Mo = (t, n, e, s) => {
    co(e) && vo(t, e);
    if (s) {
        const s = ho(n, cr, null) !== null;
        if (s) {
            return;
        }
        oo(e) ? en(t, Ps(e.node)) : sn(t, e, n => {
            en(t, Ps(n.node));
        });
    }
    const o = e.previousSibling;
    const r = e.nextSibling;
    o ? o.nextSibling = r : n.firstChild = r;
    r ? r.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const To = (t, n, e, s = !0) => {
    const o = Io(n, !0);
    if (o && s) {
        if (oo(n)) {
            en(t, Is(n.node));
        } else {
            const e = No(n, !1);
            e && e.firstChild === n && e.lastChild === n ? en(t, Is(o)) : sn(t, n, n => {
                en(t, Ps(n.node));
            });
        }
    }
    const r = e.previousSibling;
    r ? r.nextSibling = null : n.firstChild = null;
    n.lastChild = r;
};

const Fo = t => {
    const n = ma(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = nl(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = tl(t);
            switch (n) {
              case He:
                return 512;

              case Ye:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const zo = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Do = (t, n, e) => {
    vo(t, n);
    n.text = e;
    en(t, Ns(n.node, e));
};

const Lo = t => {
    if (co(t)) {
        return null;
    }
    let n = t.firstChild;
    n === void 0 && (n = Uo(t));
    return n;
};

const Uo = n => {
    const e = ma(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && Qo(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = Zo(e);
            const o = el(e)?.qVNodeData?.get(e);
            const r = ((n, e, s, o) => {
                yo(n);
                if (o) {
                    if (o.charCodeAt(0) === Re && o.charCodeAt(1) === Re) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const r = rl(n, s, e);
                        if (!o) {
                            return r;
                        }
                    }
                    return function r(n, e, s, o) {
                        let r = 0;
                        let i = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | r << 12;
                            r++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            i || (n.firstChild = i = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = dl(t);
                            return !n || n && fn(t);
                        };
                        let $ = null;
                        il(e, (p, y, m, w, b) => {
                            if (cl(p())) {
                                for (;d(o); ) {
                                    o = Go(o);
                                    if (!o) {
                                        throw ge(27, [ e, p(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;cl(p()); ) {
                                    t *= 10;
                                    t += m() - 48;
                                }
                                for (;t--; ) {
                                    const n = no(o);
                                    yo(n);
                                    u(n);
                                    o = Go(o);
                                    for (;dl(o) && fn(o); ) {
                                        o = Go(o);
                                        if (!o && t > 0) {
                                            throw ge(27, [ e, p(), b ]);
                                        }
                                    }
                                }
                            } else if (p() === 59) {
                                $o(n, Ne, y());
                            } else if (p() === 60) {
                                ($ ||= []).push(n);
                                $o(n, Ce, y());
                            } else if (p() === 61) {
                                h || (h = Tn(s));
                                const t = y();
                                h.gn(parseInt(t), n);
                            } else if (p() === 62) {
                                $o(n, Ze, y());
                            } else if (p() === 64) {
                                const e = w(b + 1) === Re;
                                let s;
                                if (e) {
                                    m();
                                    s = decodeURI(t(y()));
                                    m();
                                } else {
                                    s = y();
                                }
                                n.key = s;
                            } else if (p() === 91) {
                                $o(n, tr, y());
                            } else if (p() === 94) {
                                $o(n, nr, y());
                            } else if (p() === 96) {
                                h || (h = Tn(s));
                                un(n, y(), h);
                            } else if (p() === 63) {
                                h || (h = Tn(s));
                                n.slotParent = go(h.rootVNode, y());
                            } else if (p() === 93) {
                                $o(n, Me, y());
                            } else if (p() === 123) {
                                m();
                                u(ro());
                                al.push(n, i, c, l, r);
                                r = 0;
                                n = c;
                                i = c = null;
                            } else if (p() === Re) {
                                const e = t(y());
                                const s = t(y());
                                $o(n, e, s);
                            } else if (p() === 125) {
                                m();
                                n.lastChild = c;
                                r = al.pop();
                                l = al.pop();
                                c = al.pop();
                                i = al.pop();
                                n = al.pop();
                            } else if (p() === 126) {
                                const e = t(y());
                                $o(n, Oe, e);
                            } else {
                                for (;dl(o) && fn(o); ) {
                                    o = Go(o);
                                }
                                const t = o && Bo(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;fl(p()); ) {
                                    n += m() - 97;
                                    n *= 26;
                                }
                                n += m() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new ei(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if ($) {
                            h || (h = Tn(s));
                            for (let t = 0; t < $.length; t++) {
                                h.ensureProjectionResolved($[t]);
                            }
                            $ = null;
                        }
                        n.lastChild = c;
                        return i;
                    }(n, o, e, s);
                }
                return rl(n, s);
            })(n, e, s, o);
            return r;
        })(e);
    }
    return s;
};

let Wo = null;

const Qo = t => {
    Wo || (Wo = t.hasAttribute);
    return Wo.call(t, Qe);
};

let Vo = null;

const Jo = (t, n) => {
    Vo || (Vo = t.getAttribute);
    return Vo.call(t, n);
};

const Bo = Zs("nodeType");

const Ho = t => {
    const n = Bo(t);
    return n === 3 || n === 1;
};

let Yo = null;

const Go = t => {
    Yo || (Yo = Ks(t, "nextSibling"));
    Ko || (Ko = Ks(t, "firstChild"));
    for (;t; ) {
        t = Yo.call(t);
        if (t !== null) {
            const n = Bo(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(Ue)) {
                    return ln(t, De, Yo, Ko);
                }
                if (t.nodeValue?.startsWith(Le)) {
                    return ln(t, [ De, We ], Yo, Ko);
                }
                if (n?.startsWith(Qe)) {
                    for (;t && (t = Yo.call(t)) && (Bo(t) !== 8 || !t.nodeValue?.startsWith(Ve)); ) {}
                }
            }
        }
    }
    return t;
};

function ln(t, n, e, s) {
    const o = typeof n === "string";
    const r = n.length;
    for (;t; ) {
        const i = t.nodeValue;
        let c;
        if (o) {
            c = i?.startsWith(n);
        } else {
            for (let t = 0; t < r; t++) {
                if (i?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = Xo(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const Xo = Zs("parentNode");

let Ko = null;

const Zo = t => {
    Ko || (Ko = Ks(t, "firstChild"));
    t = t && Ko.call(t);
    if (t && Bo(t) === 8 && t.nodeValue?.startsWith(Ue)) {
        Yo || (Yo = Ks(t, "nextSibling"));
        return ln(t, De, Yo, Ko);
    }
    for (;t && !Ho(t); ) {
        t = Go(t);
    }
    return t;
};

const tl = Zs("namespaceURI");

const nl = Zs("nodeName");

const el = Zs("ownerDocument");

const rl = (t, n, e) => {
    let s = null;
    const o = () => {
        for (;dl(r) && fn(r); ) {
            r = Go(r);
        }
    };
    let r = n;
    o();
    let i = null;
    for (;r; ) {
        const n = Bo(r);
        let e = null;
        if (n === 3) {
            e = eo(r, r.textContent ?? void 0);
        } else if (n === 1) {
            e = no(r);
            yo(e);
        }
        if (e) {
            e.parent = t;
            i && (i.nextSibling = e);
            e.previousSibling = i;
            i = e;
        }
        s || (t.firstChild = s = i);
        r = Go(r);
        o();
    }
    t.lastChild = i || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        il(e, (e, s) => {
            if (e() === 61) {
                n || (n = Tn(t.node));
                const e = s();
                n.gn(parseInt(e), t);
            } else if (e() === 96) {
                n || (n = Tn(t.node));
                un(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function un(t, n, e) {
    if (t[Xr]) {
        const s = t[Xr];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e._(n));
    } else {
        Object.defineProperty(t, Xr, {
            get() {
                const s = e._(n);
                t[Xr] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, Xr, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const il = (t, n) => {
    let e = 0;
    let s = 0;
    let o = 0;
    const r = n => n < t.length ? t.charCodeAt(n) : 0;
    const i = () => o !== 0 ? o : o = r(e);
    const c = () => {
        s = i();
        o = 0;
        e++;
        return s;
    };
    const l = () => {
        c();
        const n = e;
        for (;i() <= 58 && o !== 0 || o === 92 || o === 95 || o >= 65 && o <= 90 || o >= 97 && o <= 122; ) {
            c();
        }
        return t.substring(n, e);
    };
    for (;i() !== 0; ) {
        n(i, l, c, r, e);
    }
};

const sl = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        mo(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(ur) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const ol = (t, n) => {
    let e = ll(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = ll(e);
    }
    return !1;
};

const ll = t => t.parent || t.slotParent;

const ul = t => {
    if (t === null || fo(t)) {
        return null;
    }
    return t.node;
};

function cn(t = 20, n = "", e = !1, s = !1, o = !0, r = null) {
    if (this && !r) {
        try {
            r = function t(n) {
                let e = n;
                for (;e; ) {
                    if (so(e)) {
                        const t = zn(e.node);
                        if (!t) {
                            return null;
                        }
                        return Fn(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let i = this;
    if (t === 0) {
        return "...";
    }
    if (i === null) {
        return "null";
    }
    if (i === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (co(i)) {
            c.push(Ln(zo(i)));
        } else if (fo(i)) {
            const e = i.flags >>> 12;
            const s = [ "[" + e + "]" ];
            i.dirty && s.push(" dirty:" + i.dirty);
            r && sl(r, i).forEach(t => {
                if (t !== xe && t !== fr) {
                    const n = ho(i, t, null);
                    s.push(" " + t + "=" + Ln(n));
                }
            });
            const l = (o ? "[34m" : "") + (qe[ho(i, xe, null) || "V"] || qe.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Lo(i);
            u && c.push("  " + cn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (so(i)) {
            const s = Fo(i);
            const l = [];
            Kt(i) && l.push(" cursor");
            i.dirty && l.push(" dirty:" + i.dirty);
            i.dirtyChildren && l.push(` dirtyChildren[${i.dirtyChildren.length}]`);
            const u = r ? sl(r, i) : [];
            for (const t of u) {
                const n = ho(i, t, null);
                l.push(" " + t + "=" + Ln(n));
            }
            const f = ul(i);
            if (f) {
                const t = el(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + Ln(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + Ln(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (uo(i) || e) {
                const e = Lo(i);
                e && c.push("  " + cn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        i = s && i.nextSibling || null;
    } while (i);
    return c.join("\n" + n);
}

const cl = t => 48 <= t && t <= 57;

const fl = t => 97 <= t && t <= 122;

function fn(t) {
    return !t.hasAttribute(ur) || t.nodeName === "STYLE" && (t.hasAttribute(Ne) || t.hasAttribute(Ae));
}

const al = [];

const hl = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw ge(26, [ n ]);
};

const dl = t => t && typeof t == "object" && Bo(t) === 1;

const $l = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!fo(t) || ho(t, Ce, null) === null); ) {
            const e = t.slotParent;
            const s = fo(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

let pl;

let wa;

Kn && import("node:async_hooks").then(t => {
    wa = new t.AsyncLocalStorage;
}).catch(() => {});

function an(t) {
    if (wa) {
        const t = wa.getStore();
        if (t) {
            return t;
        }
    }
    if (pl === void 0) {
        const n = ml();
        if (n && n.wt) {
            return n.wt;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return pl;
}

function hn(t, n) {
    if (wa) {
        return wa.run(t, n);
    }
    const e = pl;
    try {
        pl = t;
        return n();
    } finally {
        pl = e;
    }
}

let yl;

const ml = () => yl;

const wl = () => {
    const t = ml();
    if (!t || t.bt !== Ge) {
        throw ge(10);
    }
    return t;
};

function dn(t, n, ...e) {
    return $n.call(this, t, n, e);
}

function $n(t, n, e) {
    const s = yl;
    try {
        yl = t;
        return n.apply(this, e);
    } finally {
        yl = s;
    }
}

const bl = (t, n) => {
    const e = Tn(n);
    const s = go(e.rootVNode, n);
    const o = e.wt;
    o && function r(t) {
        if (wa) {
            wa.enterWith(t);
            return;
        }
        pl = t;
    }(o);
    const i = yn(o, s, t);
    i.O = e;
    return i;
};

function pn(t, n, e) {
    const s = {
        p: n,
        bt: Ge,
        vt: void 0,
        wt: t,
        O: e,
        gt: void 0
    };
    oe(s);
    return s;
}

function yn(t, n, e) {
    const s = t || (e && me(e) && "locale" in e ? e.locale : void 0);
    const o = {
        p: n,
        bt: e,
        vt: void 0,
        wt: s,
        O: void 0
    };
    oe(o);
    return o;
}

const vl = (t, ...n) => {
    if (typeof t === "function") {
        if (!yl) {
            return t(...n);
        }
        {
            const e = yl.vt;
            try {
                yl.vt = void 0;
                return t(...n);
            } finally {
                yl.vt = e;
            }
        }
    }
    if (zu(t)) {
        return t.untrackedValue;
    }
    return Ku(t);
};

const gl = /*#__PURE__*/ pn(void 0, void 0, void 0);

const Sl = (t, n, e, s, o) => {
    const r = gl.vt;
    const i = gl.O;
    try {
        gl.vt = $(n, e, o);
        gl.O = s;
        return $n(gl, t);
    } finally {
        gl.vt = r;
        gl.O = i;
    }
};

const kl = (t, n, e, s, o) => {
    t instanceof Gi && t.p !== n && n && (t.p = n);
    return Sl(() => t.value, n, e, s, o);
};

const xl = () => ml()?.p;

const ql = () => {
    const t = ml();
    if (t) {
        return t.bt;
    }
};

const Rl = () => {
    const t = ml();
    if (t) {
        return t.O;
    }
};

const Cl = t => t;

const jl = t => t.l || Promise.resolve();

const El = () => {
    const t = wl();
    const n = t.p;
    const e = n;
    let s = t.O.getHostProp(e, tr);
    if (s === null) {
        s = [];
        t.O.setHostProp(e, tr, s);
    }
    let o = t.O.getHostProp(e, nr);
    o === null && (o = 0);
    t.O.setHostProp(e, nr, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => {
            ee && cc(t);
            return s[o] = t;
        },
        i: o,
        iCtx: t
    };
};

const Ol = t => /*#__PURE__*/ Object.freeze({
    id: br(t)
});

const _l = (t, n) => {
    const {val: e, set: s, iCtx: o} = El();
    if (e !== void 0) {
        return;
    }
    ee && Pl(t);
    ee && cc(n);
    o.O.setContext(o.p, t, n);
    s(1);
};

const Al = (t, n) => {
    const {val: e, set: s, iCtx: o} = El();
    if (e !== void 0) {
        return e;
    }
    ee && Pl(t);
    const r = o.O.resolveContext(o.p, t);
    if (typeof n === "function") {
        return s(dn(void 0, n, r));
    }
    if (r !== void 0) {
        return s(r);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw ge(8, [ t.id ]);
};

const Pl = t => {
    if (!me(t) || typeof t.id !== "string" || t.id.length === 0) {
        throw ge(11, [ t ]);
    }
};

const Il = t => {
    const n = (() => {
        const t = ml();
        if (!t) {
            throw ge(9);
        }
        return t;
    })();
    const e = n.p;
    if (!e) {
        return;
    }
    return n.O?.resolveContext(e, t);
};

const Nl = /*#__PURE__*/ Ol("qk-error");

const Ml = [ void 0, null, !0, !1, "", yi, mi, Ri, Oi, pi, ws, ps, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER ];

const Tl = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER" ];

const Fl = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription" ];

function mn(t, n, e) {
    let s = n.St;
    let o = n.kt;
    const r = Qr();
    if (r) {
        const t = r.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const i = (t => ke(t) && t.St == Se)(n);
    if (i) {
        const e = n.resolved;
        o = "";
        s = t.xt(null, 0, e) + "";
    } else {
        o || (o = t.qt(n.ft));
        if (!o) {
            throw ge(14, [ n.St ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    c && c.length > 0 && (l = c.map(n => "" + t.Rt(n)).join(" "));
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function wn(t, n, e, s) {
    return Oc(t, n, null, null, e, s);
}

function bn(t, n) {
    const [e, s, o] = t.split("#");
    return wn(e, s, o || null, n);
}

const zl = new WeakMap;

const Dl = new Map;

const Ll = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t._(e);

      case 2:
        if (!t.It) {
            return pi;
        }
        const s = t.It[e];
        return s === -1 || s === void 0 ? pi : t._(s);

      case 14:
        return e;

      case 3:
        return Ml[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const [s, o, r] = e.split("#");
                const i = t._(s);
                const c = t._(o);
                n = wn(i, c, r || null, t);
            } else {
                n = wn("", e + "", null, t);
            }
            return n;
        }

      case 20:
        return new Mu(-1, -1, null, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 15:
        return Error();

      case 21:
        return Uc(null);

      case 22:
        return new ci(t, 0);

      case 23:
        return new Gi(t, null, null, null);

      case 24:
        return new Ai(t, null);

      case 25:
        return new Ii(t, null, void 0, {
            interval: 0
        });

      case 26:
        return new Mi(t, null);

      case 27:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const r = Ll(t, s, o);
            const i = tc(r, 0, t);
            qu(s) && Dl.set(r, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = r;
            return i;
        }

      case 13:
        return new URLSearchParams(e);

      case 28:
        return new FormData;

      case 29:
        return new ts(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 17:
        return new Set;

      case 18:
        return new Map;

      case 16:
        let r;
        let i;
        const c = new Promise((t, n) => {
            r = t;
            i = n;
        });
        zl.set(c, [ r, i ]);
        c.catch(() => {});
        return c;

      case 19:
        const l = e.length;
        const u = l >>> 2;
        const f = l & 3;
        const a = u * 3 + (f ? f - 1 : 0);
        return new Uint8Array(a);

      case 30:
        return d(null);

      case 10:
        return vn(t, e);

      case 11:
        const h = vn(t, e);
        if (io(h)) {
            Uo(h);
            return ul(h);
        }
        throw ge(17, [ typeof h ]);

      case 31:
        return new Xi({});

      case 32:
        return new Ci(null, null, null, null);

      default:
        throw ge(18, [ n ]);
    }
};

function vn(t, n) {
    return n ? t.rootVNode ? go(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Ul = (t, n, e) => {
    let s = null;
    let o = null;
    if (ve(t)) {
        o = t;
    } else {
        if (!be(t)) {
            throw ge(7, [ t ]);
        }
        s = t;
    }
    return Oc(s, n, null, o, e);
};

const Wl = (t, n, e) => Oc(null, n, t, null, e);

const Ql = (t, n) => Oc(null, t, null, null, n);

const Vl = (t, n, e) => {
    const s = Ql(t, e);
    s.Sn.dev = n;
    return s;
};

const Jl = (t, n, e, s) => {
    const o = Ul(t, n, s);
    o.Sn.dev = e;
    return o;
};

const Bl = (t, n, e, s) => {
    const o = Wl(t, n, s);
    o.Sn.dev = e;
    return o;
};

const Hl = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

function gn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Yl = (t, n, e) => new Gi(null, t, n, e || null);

class Gl {
    kn;
    xn=0;
    It=[];
    qn=0;
    Rn=new Set;
    Cn=new Map;
    jn;
    En=new Map;
    Mt;
    constructor(t) {
        this.kn = t;
        this.Mt = t.Mt;
    }
    async serialize() {
        await this.outputRoots();
    }
    outputArray(t, n, e) {
        this.Mt.write("[");
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Mt.write(Fr) : s = !0;
            e(t[n], n);
        }
        this.Mt.write("]");
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    output(t, n, e) {
        if (typeof n === "number") {
            this.Mt.write(t + Fr + n);
        } else if (typeof n === "string") {
            const e = this.stringNeedsJsonEscape$(n) ? JSON.stringify(n) : '"' + n + '"';
            this.Mt.write(t + Fr);
            let s = -1;
            let o = 0;
            for (;(s = e.indexOf("</", o)) !== -1; ) {
                this.Mt.write(e.slice(o, s));
                this.Mt.write("<\\/");
                o = s + 2;
            }
            this.Mt.write(o === 0 ? e : e.slice(o));
        } else {
            this.Mt.write(t + Fr);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.kn.getSeenRef(t);
        const o = !e && this.Cn.get(t);
        if (!s) {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.kn.On(t, this.jn, n);
            }
            s = this.kn.Rt(t, !0);
        }
        if (s.jn) {
            if (this.jn) {
                this.kn._n(s);
            } else {
                this.kn._n(s, n);
                t = this.kn.An[n];
            }
        }
        if (typeof o === "number") {
            this.It[o] = s.Pn;
            this.Cn.delete(t);
        }
        const r = t instanceof ru ? t.In : s.Pn;
        if (!this.jn && r === n) {
            return s;
        }
        this.output(1, r);
    }
    writeValue(t, n) {
        if (dc(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                t.length === 0 ? this.output(3, 4) : (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, "" + t);
                break;

              case "symbol":
                t === Ri ? this.output(3, 7) : t === Oi ? this.output(3, 8) : t === pi && this.output(3, 9);
                break;

              case "function":
                if (t === ws) {
                    this.output(3, 10);
                } else if (t === ps) {
                    this.output(3, 11);
                } else if (ke(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = mn(this.kn, t, !0);
                        let o;
                        if (n !== "") {
                            o = `${this.kn.Rt(n)}#${this.kn.Rt(e)}${s ? "#" + s : ""}`;
                            const r = this.En.get(o);
                            if (r) {
                                const t = this.kn.Rt(r);
                                this.output(1, t);
                                return;
                            }
                            this.En.set(o, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!Qc(t)) {
                        throw ge(34, [ "" + t ]);
                    }
                    {
                        const [n] = t[Wc];
                        this.kn.Nn.add(n.St);
                        this.output(21, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === yi) {
                    this.output(3, 5);
                } else if (t === mi) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof ru) {
                    this.output(1, t.In);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.jn;
                        this.jn = e;
                        this.writeObjectValue(t);
                        this.jn = n;
                    }
                }
                break;

              default:
                throw ge(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (qi(t)) {
            const n = t[hi];
            this.output(30, [ nu(n), n.varProps, n.constProps, t[di].$ ]);
        } else if (t instanceof Xi) {
            this.output(31, [ t.data.W, t.data.lt ]);
        } else if (t instanceof Ci) {
            this.output(32, [ t.consumer, t.property, t.data ]);
        } else if (Zu(t)) {
            const n = Hu(t);
            const e = Yu(t);
            const s = n.R;
            const o = n.$;
            const r = [];
            for (const t in e) {
                const n = e[t];
                const s = this.kn.h.get(n);
                s && r.push(s);
            }
            const i = [ e, s, o, ...r ];
            for (;i[i.length - 1] === void 0; ) {
                i.pop();
            }
            this.output(27, i);
        } else if (Qu(t)) {
            const n = t[yc](t);
            if (hr(n)) {
                const t = this.resolvePromise(n, (t, n) => new Xl(26, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.jn.Pn;
                this.jn = this.jn.jn;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        dc(s) || n.push(e, s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.kn.Mn(t)) {
            t.Tn.vnodeData[0] |= 16;
            this.output(11, t.Tn.id);
        } else if (t instanceof ci) {
            if (t instanceof Mi) {
                const n = function e(t, n) {
                    if (n === Ri) {
                        return n;
                    }
                    return $r(t.Yt.resolved || t.Yt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && yc in n && (e = n[yc](n));
                        e === void 0 && (e = Ri);
                        return e;
                    });
                }(t, t.Bt);
                if (hr(n)) {
                    const e = this.resolvePromise(n, (n, e) => new Xl(26, n, e, t.$, t.Yt));
                    this.output(2, e);
                } else {
                    this.output(26, [ t.Yt, t.$, n ]);
                }
                return;
            }
            if (t instanceof Gi) {
                this.output(23, [ ...Sn(this.kn, t), t.R, t.p, ...t.$ || [] ]);
            } else if (t instanceof Ai) {
                let n = t.Bt;
                const e = t.R & 16;
                const s = t.R & 8;
                const o = t.R & 1;
                const r = dc(t.Bt);
                const i = t instanceof Ii;
                const c = i && t.jt > 0 ? t.jt : void 0;
                const l = i && t.cn !== 1 ? t.cn : void 0;
                const u = i && t.fn !== 0 ? t.fn : void 0;
                const f = i && t.R & -25 || void 0;
                o || r ? n = Ri : e ? n = t.Bt : s && (n = Ri);
                const a = [ t.Yt, t.$ ];
                if (i) {
                    a.push(t.m, t.k, t.sn);
                    a.push(f || void 0);
                }
                let h = !1;
                if (n !== Ri || c !== void 0 || l !== void 0 || u !== void 0) {
                    a.push(n);
                    n === void 0 && (h = !0);
                }
                if (i) {
                    a.push(c);
                    a.push(l);
                    a.push(u);
                }
                this.output(i ? 25 : 24, a, h);
            } else {
                const n = t.Bt;
                const e = n === void 0;
                const s = [ n ];
                t.$ && s.push(...t.$);
                this.output(22, s, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, "" + t);
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(15, n);
        } else if (this.kn.Fn(t)) {
            const n = this.kn.Rt(t);
            this.kn.zn(t, "q:id", n + "");
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                Kl(e, t => this.kn.Rt(t));
                e[0] |= 16;
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    const s = n.vnodeData;
                    if (s) {
                        for (let t = 0; t < s.length; t++) {
                            const n = s[t];
                            if (Zl(n)) {
                                const t = kn(n);
                                t && this.kn.Rt(t);
                            }
                        }
                        s[0] |= 16;
                    }
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(28, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, "" + t);
        } else if (t instanceof Set) {
            this.output(17, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(18, n);
        } else if (es(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(29, n);
        } else if (t instanceof Mu) {
            const n = [ t.Pt, t.R, t.Pn, t.$t, t.Tt ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(20, n);
        } else if (hr(t)) {
            const n = this.resolvePromise(t, (t, n) => new Xl(16, t, n));
            this.output(2, n);
        } else if (t instanceof Xl) {
            if (t.Dn === 26) {
                if (t.Pt) {
                    this.output(26, [ t.Pt, t.$, t.Ln ]);
                } else {
                    if (!t.Un) {
                        console.error(t.Ln);
                        throw ge(33);
                    }
                    {
                        const n = this.jn.Pn;
                        this.jn = this.jn.jn;
                        this.writeValue(t.Ln, n);
                    }
                }
            } else {
                this.output(16, [ t.Un, t.Ln ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(19, s);
        } else if (t instanceof tu) {
            const n = t.Wn;
            if (this.getSeenRefOrOutput(n, this.jn.Pn, !0)) {
                let t = this.Cn.get(n);
                if (t === void 0) {
                    t = this.qn++;
                    this.Cn.set(n, t);
                    this.It[t] = -1;
                }
                this.output(2, t);
            }
        } else {
            if (!io(t)) {
                throw ge(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.qn++;
        t.then(s => {
            this.Rn.delete(t);
            this.It[e] = this.kn.Rt(n(!0, s));
        }).catch(s => {
            this.Rn.delete(t);
            this.It[e] = this.kn.Rt(n(!1, s));
        });
        this.Rn.add(t);
        return e;
    }
    async outputRoots() {
        this.Mt.write("[");
        const {An: t} = this.kn;
        for (;this.xn < t.length || this.Rn.size; ) {
            this.xn !== 0 && this.Mt.write(Fr);
            let n = !1;
            for (;this.xn < t.length; this.xn++) {
                n ? this.Mt.write(Fr) : n = !0;
                this.writeValue(t[this.xn], this.xn);
            }
            if (this.Rn.size) {
                try {
                    await Promise.race(this.Rn);
                } catch {}
            }
        }
        if (this.It.length) {
            let t = this.It.length - 1;
            for (;t >= 0 && this.It[t] === -1; ) {
                t--;
            }
            if (t >= 0) {
                this.Mt.write(Fr);
                this.Mt.write(14 + Fr);
                const n = t === this.It.length - 1 ? this.It : this.It.slice(0, t + 1);
                this.outputArray(n, !0, t => {
                    this.Mt.write(t + "");
                });
            }
        }
        this.Mt.write("]");
    }
}

class Xl {
    Dn;
    Un;
    Ln;
    $;
    Pt;
    constructor(t, n, e, s, o) {
        this.Dn = t;
        this.Un = n;
        this.Ln = e;
        this.$ = s;
        this.Pt = o;
    }
}

const Kl = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (Zl(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || t === Ze && Tr(s)) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const Zl = t => typeof t === "object" && t !== null && !Tr(t);

function Sn(t, n) {
    n.Ct && n.Ct[0] === "{" && (n.Ct = `(${n.Ct})`);
    const e = t.xt(n.Ct, n.dt.length, n.ht);
    return [ e, n.dt ];
}

function kn(t) {
    return Object.prototype.hasOwnProperty.call(t, Te) ? t[Te] : void 0;
}

class tu {
    Wn;
    constructor(t) {
        this.Wn = t;
    }
}

const nu = t => new tu(t);

let eu = () => !1;

class ru {
    In;
    constructor(t) {
        this.In = t;
    }
}

class iu {
    NodeConstructor;
    DomRefConstructor;
    qt;
    zn;
    h;
    Mt;
    Qn=new Map;
    Vn=new Map;
    Jn=[];
    An=[];
    Et=new Set;
    At=new Set;
    _t=new Set;
    Nn=new Set;
    Bn;
    constructor(t, n, e, s, o, r) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.qt = e;
        this.zn = s;
        this.h = o;
        this.Mt = r;
        this.Bn = new Gl(this);
    }
    async Nt() {
        return await this.Bn.serialize();
    }
    getSeenRef(t) {
        return this.Qn.get(t);
    }
    On(t, n, e) {
        const s = {
            Pn: e,
            jn: n
        };
        this.Qn.set(t, s);
        return s;
    }
    Hn(t) {
        const n = [];
        for (;t.jn; ) {
            n.unshift(t.Pn);
            t = t.jn;
        }
        n.unshift(t.Pn);
        return n.join(" ");
    }
    _n(t, n) {
        const e = this.Hn(t);
        n === void 0 && (n = this.An.length);
        this.An[n] = new ru(e);
        t.jn = null;
        t.Pn = n;
    }
    Rt(t, n = !1) {
        let e = this.Qn.get(t);
        let s;
        if (e) {
            e.jn && this._n(e);
            s = e.Pn;
        } else {
            s = this.An.length;
            e = {
                Pn: s
            };
            this.Qn.set(t, e);
            this.An.push(t);
        }
        return n ? e : s;
    }
    Fn(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    Mn(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    Yn(t) {
        const n = this.Qn.get(t);
        return n && (n.jn ? void 0 : n.Pn);
    }
    xt(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || "" + e);
        let o = this.Vn.get(t);
        if (o === void 0) {
            o = this.Jn.length;
            this.Vn.set(t, o);
            if (s) {
                this.Jn.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.Jn.push(e += ")=>" + t);
            }
        }
        return o;
    }
}

const su = (t, n, e, s, o, r) => {
    if (!r) {
        const t = [];
        r = {
            write: n => t.push(n),
            toString: () => t.join("")
        };
    }
    eu = n ? t => t instanceof n : () => !1;
    return new iu(t, n, e, s, o, r);
};

class ou {
    Gn;
    h;
    wt;
    _;
    Ft;
    Xn=0;
    Kn=null;
    Zn=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.Ft = t;
        this.wt = n;
        this.Gn = zr;
        this.h = new WeakMap;
        this._ = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return kl(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return su(t, n, e, this.setHostProp.bind(this), this.h, s);
    }
    yt() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

class lu {}

function xn(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function qn(t, e, s) {
    const o = [ e ];
    const r = t => o.push(t);
    await (async () => {
        for (;o.length; ) {
            const e = o.pop();
            if (e === lu) {
                const t = o.pop();
                await n(() => o.push(t()));
                continue;
            }
            if (typeof e === "function") {
                e === Promise ? o.push(await o.pop()) : await e.apply(t);
                continue;
            }
            Rn(t, r, e, s);
        }
    })();
}

function Rn(t, n, e, s) {
    if (e == null) {
        t.textNode("");
    } else if (typeof e === "boolean") {
        t.textNode("");
    } else if (typeof e === "number") {
        t.textNode(e + "");
    } else if (typeof e === "string") {
        t.textNode(e);
    } else if (typeof e === "object") {
        if (Array.isArray(e)) {
            for (let t = e.length - 1; t >= 0; t--) {
                n(e[t]);
            }
        } else if (zu(e)) {
            (function s(t, n) {
                const e = n instanceof Gi ? n.ct() : n;
                if (e instanceof Ii) {
                    const n = e.jt;
                    if (n > 0) {
                        t.Rt(e);
                        t.Et.add(e);
                    }
                }
            })(t.serializationCtx, e);
            t.openFragment(mi);
            const o = t.getOrCreateLastNode();
            const r = e instanceof Gi ? e.ct() : e;
            n(t.closeFragment);
            n(() => kl(r, o, ".", t));
            n(lu);
        } else if (hr(e)) {
            t.openFragment(mi);
            n(t.closeFragment);
            n(e);
            n(Promise);
            n(() => t.streamHandler.flush());
        } else if (function o(t) {
            return !!t[Symbol.asyncIterator];
        }(e)) {
            n(async () => {
                for await (const n of e) {
                    await qn(t, n, {
                        currentStyleScoped: s.currentStyleScoped,
                        parentComponentFrame: s.parentComponentFrame
                    });
                    t.streamHandler.flush();
                }
            });
        } else {
            const o = e;
            const r = o.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = gi(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(o, s.currentStyleScoped);
                let i = null;
                const c = t.openElement(r, o.key, o.varProps, o.constProps, s.currentStyleScoped, i, !!(o.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else if (!t.isHtml && !t._didAddQwikLoader) {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    t._didAddQwikLoader = !0;
                }
                const l = o.children;
                l != null && n(l);
            } else if (ve(r)) {
                if (r === ps) {
                    const e = o.key != null ? {
                        [Ke]: o.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = o.children;
                    s != null && n(s);
                } else if (r === ws) {
                    const e = s.parentComponentFrame;
                    if (e) {
                        const r = e.componentNode.id || "";
                        const i = {};
                        i["q:sparent"] = r;
                        t.openProjection(i);
                        const c = e.componentNode;
                        const l = t.getOrCreateLastNode();
                        const u = function f(t, n, e) {
                            const s = n.constProps;
                            if (s && typeof s == "object" && "name" in s) {
                                const n = s.name;
                                if (n instanceof Gi) {
                                    return kl(n, t, ":", e);
                                }
                            }
                            return gi(n, "name") || "";
                        }(c, o, t);
                        i[Oe] = u;
                        n(xn(s, s.currentStyleScoped, s.parentComponentFrame));
                        n(t.closeProjection);
                        const a = o.children || null;
                        const h = e.consumeChildrenForSlot(l, u) || a;
                        a && h !== a && t.addUnclaimedProjection(e, "", a);
                        n(h);
                        n(xn(s, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = mi;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === gs) {
                    t.commentNode(gi(o, "data") || "");
                } else if (r === ks) {
                    t.streamHandler.flush();
                    const e = o.children;
                    let r;
                    r = ve(e) ? e({
                        async write(n) {
                            await qn(t, n, {
                                currentStyleScoped: s.currentStyleScoped,
                                parentComponentFrame: s.parentComponentFrame
                            });
                            t.streamHandler.flush();
                        }
                    }) : e;
                    n(r);
                    hr(r) && n(Promise);
                } else if (r === vs) {
                    t.htmlNode(gi(o, "data"));
                } else if (r === Ss) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(o.children);
                } else if (Qc(r)) {
                    const e = {};
                    t.openComponent(e);
                    const i = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(o.children, s.currentStyleScoped, s.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[Wc];
                        const r = n.props;
                        r && r.children && delete r.children;
                        s.setProp(Ce, o);
                        s.setProp(Ze, r);
                        n.key !== null && s.setProp(Ke, n.key);
                        return ms(t, s, s, o, r);
                    })(t, o, r);
                    n(xn(s, s.currentStyleScoped, s.parentComponentFrame));
                    n(t.closeComponent);
                    if (hr(l)) {
                        n(async () => {
                            const t = await l;
                            const e = mr(i.getProp(Ne));
                            n(t);
                            n(xn(s, e, c));
                        });
                    } else {
                        n(l);
                        const t = mr(i.getProp(Ne));
                        n(xn(s, t, c));
                    }
                } else {
                    const e = {
                        [Ke]: o.key
                    };
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = t.getParentComponentFrame();
                    const i = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return ms(t, o, n, e, s.props);
                    })(t, s && s.componentNode, r, o);
                    n(i);
                    hr(i) && n(Promise);
                }
            }
        }
    }
}

const uu = () => xc;

const cu = async t => {
    const [n, e] = xc;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = Un(n.O, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const fu = (t, n) => {
    const {val: e, set: s, iCtx: o} = El();
    if (e) {
        return e;
    }
    const r = Oc(null, "_rsc", cu, null, [ t, {} ], o.O);
    const i = Fi(r, {
        timeout: n?.timeout,
        container: o.O,
        concurrency: 0
    });
    i.j();
    const c = {
        __brand: "resource",
        signal: i,
        get value() {
            return i.promise().then(() => i.error ? Promise.reject(i.error) : i.value.r);
        },
        get loading() {
            return i.loading;
        }
    };
    s(c);
    return c;
};

const au = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (hr(t)) {
        return t.then(n, s);
    }
    const o = hu(t);
    const r = o ? t.signal : t;
    if (e && r.loading) {
        return e();
    }
    if (s && r.error) {
        return s(r.error);
    }
    const i = o ? r.value?.r : r.value;
    return hr(i) ? i.then(n, s) : n(i);
};

const hu = t => t && t.__brand === "resource";

function Cn(t, n, e, s) {
    let o = null;
    const r = e;
    const i = t => {
        o = (o == null ? "" : o + "|") + t;
    };
    const c = n => {
        n.St.startsWith("_") || !n.Ot?.length && !s || (n = Oc(null, "_run", A, null, [ n ]));
        return mn(t, n);
    };
    if (Array.isArray(r)) {
        for (let e = 0; e < r.length; e++) {
            const o = r[e];
            if (ke(o)) {
                i(c(o));
                jn(t, n, o);
            } else if (o != null) {
                const e = Cn(t, n, o, s);
                e && i(e);
            }
        }
    } else if (ke(r)) {
        o = c(r);
        jn(t, n, r);
    }
    return o;
}

function jn(t, n, e) {
    const s = (t => [ t.charAt(2), t.substring(4) ])(n);
    if (s) {
        const [n, o] = s;
        const r = ((t, n) => t + ":" + n)(n, o);
        t._t.add(r);
        t.At.add(e);
    }
}

const du = (t, n) => {
    yu("q-e:", t, n);
};

const $u = (t, n) => {
    yu("q-d:", t, n);
};

const pu = (t, n) => {
    yu("q-w:", t, n);
};

const yu = (t, n, e) => {
    const {isAdded: s, addEvent: o} = mu();
    if (s) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (const s of n) {
                o(t + br(s), e);
            }
        } else {
            o(t + br(n), e);
        }
    }
};

const mu = () => {
    const t = wl();
    const n = t.p;
    const e = n;
    let s = t.O.getHostProp(e, sr);
    if (s === null) {
        s = {};
        t.O.setHostProp(e, sr, s);
    }
    let o = t.O.getHostProp(e, or);
    o === null && (o = 0);
    t.O.setHostProp(e, or, o + 1);
    let r = t.O.getHostProp(e, lr);
    if (r === null) {
        r = [];
        t.O.setHostProp(e, lr, r);
    }
    for (;r.length <= o; ) {
        r.push(!1);
    }
    return {
        isAdded: r[o],
        addEvent: (t, n) => {
            r[o] = !0;
            let e = s[t];
            e || (s[t] = e = []);
            e.push(n);
        }
    };
};

const wu = (t, n) => {
    const e = bl(t, n);
    const s = e.O;
    let o = e.p;
    if (!s || !o) {
        return;
    }
    if (!s.getHostProp(o, Ce)) {
        const t = s.getParentHost(o);
        if (!t) {
            return;
        }
        o = t;
    }
    const r = s.getHostProp(o, Ce);
    if (r) {
        const t = r.Sn;
        const n = t.kt;
        if (n) {
            const e = n.split("?")[0] + "?t=" + Date.now();
            t.kt = e;
            t.te = void 0;
            r.resolved = void 0;
            nn(s, o, 4);
        }
    }
};

let bu;

function En(t) {
    const n = ml();
    if (!n) {
        return;
    }
    bu ||= Wl(wu, "_hmr");
    $u((t => "qHmr" + t.replace(/[^a-zA-Z0-9_]/g, "_"))(t), bu);
}

function On(t, n, e, s, o) {
    const r = ro();
    $o(r, Oe, o);
    r.parent = n;
    $o(n, o, r);
    $o(r, Ce, e);
    $o(r, Ze, s);
    r.dirty = 4;
    Xt(t, r, 1);
    return r;
}

function _n(t, n) {
    $o(t, je, n);
    t.flags |= 2048;
}

function An(t, n, e) {
    $o(n, Ze, e);
    nn(t, n, 4);
}

function Pn(t, n, e, s) {
    $o(n, s, null);
    const o = [];
    St(t, o, e);
    Ro(o);
    if (e.flags & 2048) {
        const t = ho(e, je, null);
        t && t.replaceChildren();
        $o(e, je, null);
        e.flags &= -2049;
    }
}

let vu = Promise.resolve();

const gu = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const Su = (t, n) => typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !gu.has(t));

const ku = (t, n, e, s) => {
    if (e === 0) {
        return;
    }
    e !== 4 && Array.isArray(s) && (s = xu(t, s));
    switch (e) {
      case 4:
        xu(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!Su(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 20:
        const o = n;
        const r = s;
        o.Pt = r[0];
        o.R = r[1];
        o.Pn = r[2];
        o.$t = r[3];
        o.Tt = r[4];
        break;

      case 21:
        n[Wc][0] = s[0];
        break;

      case 27:
        {
            const e = Ku(n);
            const o = Dl.get(e);
            if (o) {
                Dl.delete(e);
                ku(t, e, o.t, o.v);
            }
            const [, r, i] = s;
            const c = Hu(n);
            c.R = r;
            c.$ = i;
            Mn(c.$, e);
            break;
        }

      case 22:
        {
            const t = n;
            const e = s;
            t.Bt = e[0];
            t.$ = new Set(e.slice(1));
            Nn(t.$, t);
            break;
        }

      case 23:
        {
            const e = n;
            const o = s;
            e.ht = t.getSyncFn(o[0]);
            e.dt = o[1];
            e.Bt = Ri;
            e.R = o[2];
            e.R |= 1;
            e.p = o[3];
            e.$ = new Set(o.slice(4));
            (function r(t) {
                if (t.p !== null && io(t.p)) {
                    const n = t.p;
                    const e = t.$;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (be(e)) {
                                const o = ho(n, e, null);
                                if (o !== null) {
                                    t.Bt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Lo(n);
                        e && n.firstChild === n.lastChild && co(e) && (t.Bt = zo(e));
                    }
                }
            })(e);
            Nn(e.$, e);
            break;
        }

      case 25:
        {
            const t = n;
            const e = s;
            t.Yt = e[0];
            t.$ = new Set(e[1]);
            t.m = new Set(e[2]);
            t.k = new Set(e[3]);
            t.sn = e[4];
            t.R = e[5] ?? 0;
            t.R & 64 && (t.rn = !0);
            const o = e.length > 6;
            o && (t.Bt = e[6]);
            t.Bt === Ri && (t.R |= 1);
            t.interval = e[7] ?? 0;
            t.cn = e[8] ?? 1;
            t.fn = e[9] ?? 0;
            Nn(t.$, t);
            Nn(t.m, t);
            Nn(t.k, t);
            break;
        }

      case 26:
      case 24:
        {
            const o = n;
            const r = s;
            o.Yt = r[0];
            const i = o.Yt.resolve(t).catch(() => {});
            vu = vu.finally(() => i);
            r[1] && (o.$ = new Set(r[1]));
            const c = r.length > 2;
            c && (o.Bt = r[2]);
            e !== 26 && o.Bt !== Ri && (o.R &= -2);
            Nn(o.$, o);
            break;
        }

      case 15:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                n[t[e]] = t[e + 1];
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
            }
            break;
        }

      case 29:
        {
            const t = n;
            const [e, o, r, i, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = r;
            t.constProps = i || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 17:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
            }
            break;
        }

      case 18:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
            }
            break;
        }

      case 16:
        {
            const t = n;
            const [e, o] = s;
            const [r, i] = zl.get(t);
            e ? r(o) : i(o);
            break;
        }

      case 19:
        const i = n;
        const c = atob(s);
        let l = 0;
        for (const t of c) {
            i[l++] = t.charCodeAt(0);
        }
        break;

      case 30:
        const u = n;
        const f = s;
        let a = f[0];
        if (a === pi) {
            a = new ts(ps, f[1], f[2], null, 0, null);
            a._proxy = u;
        }
        u[hi] = a;
        const h = u[di];
        h.$ = f[3];
        Mn(h.$, u);
        break;

      case 31:
        {
            const t = n;
            t.data.W = s[0];
            t.data.lt = s[1];
            break;
        }

      case 32:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            (function o(t) {
                const n = import.meta.env.TEST ? Vr() : Kn;
                const e = t.consumer;
                if (n && !e) {
                    return;
                }
                e[Xr] ||= new Map;
                e[Xr].set(t.property, t);
            })(t);
            break;
        }

      default:
        throw ge(16, [ e ]);
    }
};

const xu = (t, n, e = Array(n.length / 2)) => {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = In(t, n[s], n[s + 1]);
    }
    return e;
};

function In(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Ll(t, n, e);
    qu(n) && ku(t, s, n, e);
    return s;
}

function Nn(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function Mn(t, n) {
    if (t) {
        for (const [, e] of t) {
            Nn(e, n);
        }
    }
}

const qu = t => t >= 15 || t === 4 || t === 5;

const Ru = new WeakMap;

const Cu = Symbol();

const ju = (t, n) => {
    if (!Array.isArray(n) || io(n) || (t => me(t) && Cu in t)(n)) {
        return n;
    }
    let e = Ru.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new Eu(t, n));
        Ru.set(n, e);
    }
    return e;
};

class Eu {
    O;
    ne;
    ee;
    constructor(t, n) {
        this.O = t;
        this.ne = n;
        this.ee = this.ne.length / 2;
    }
    get(t, n, e) {
        if (n === Cu) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.ee) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const r = this.ne[o];
        const i = this.ne[o + 1];
        if (r === 0) {
            return i;
        }
        const c = this.O;
        const l = Ll(c, r, i);
        Reflect.set(t, n, l);
        this.ne[o] = 0;
        this.ne[o + 1] = l;
        qu(r) && ku(c, l, r, i);
        return l;
    }
    has(t, n) {
        if (n === Cu) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === Cu) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const r = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(r) || r < 0 || r >= this.ne.length / 2) {
            return o;
        }
        const i = r * 2;
        this.ne[i] = 0;
        this.ne[i + 1] = e;
        return !0;
    }
}

const Ou = t => 33 <= t && t <= 46;

const _u = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Ou(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function Tn(t) {
    const n = zn(t);
    if (!n) {
        throw ge(24);
    }
    return Fn(n);
}

function Fn(t) {
    const n = t;
    return n.qContainer ||= new Pu(n);
}

function zn(t) {
    return t.closest("[q\\:container]:not([q\\:container=html]):not([q\\:container=text])");
}

const Au = t => t instanceof Pu;

class Pu extends ou {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    h=new WeakMap;
    re;
    Kn;
    It=null;
    vNodeLocate=t => go(this.rootVNode, t);
    ie;
    se;
    oe=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Qe);
        if (!this.qContainer) {
            throw ge(25);
        }
        this.document = t.ownerDocument;
        this.element = t;
        this.Zn = t.getAttribute(ze);
        this.Kn = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = no(this.element);
        this.ie = [];
        this.se = [];
        const n = this.element.ownerDocument;
        n.qVNodeData || function e(t) {
            const n = "q:container";
            const e = "/" + n;
            const s = "q:ignore";
            const o = "/" + s;
            const r = "q:container-island";
            const i = "/" + r;
            const c = t;
            const l = c.qVNodeData || (c.qVNodeData = new WeakMap);
            const u = t.body;
            const f = u.getAttribute;
            const a = u.hasAttribute;
            const h = ((t, n) => {
                let e;
                for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
                    t = Object.getPrototypeOf(t);
                }
                return e || function() {
                    return this[n];
                };
            })(u, "nodeType");
            const d = t => {
                Array.from(t.querySelectorAll('script[type="qwik/vnode"]')).forEach(t => {
                    const n = t.closest("[q\\:container]");
                    n.qVnodeData = t.textContent;
                    n.qVNodeRefs = new Map;
                });
                t.querySelectorAll("[q\\:shadowroot]").forEach(t => {
                    const n = t.shadowRoot;
                    n && d(n);
                });
            };
            d(t);
            const $ = t => {
                const c = h.call(t);
                if (c === 1) {
                    const e = f.call(t, n);
                    if (e === null) {
                        if (a.call(t, "q:shadowroot")) {
                            return 6;
                        }
                        const n = a.call(t, ":");
                        return n ? 2 : 0;
                    }
                    return 3;
                }
                if (c === 8) {
                    const c = t.nodeValue || "";
                    if (c.startsWith(r)) {
                        return 65;
                    }
                    if (c.startsWith(s)) {
                        return 16;
                    }
                    if (c.startsWith(n)) {
                        return 9;
                    }
                    if (c.startsWith(i)) {
                        return 64;
                    }
                    if (c.startsWith(o)) {
                        return 32;
                    }
                    if (c.startsWith(e)) {
                        return 8;
                    }
                }
                return 0;
            };
            const p = t => {
                for (;t && (t = t.nextSibling) && $(t) === 0; ) {}
                return t;
            };
            const y = (n, e, s, o, r, i) => {
                const c = r.length;
                let u = 0;
                let f = -1;
                let a = 0;
                let h = 0;
                let d = 0;
                let m = -1;
                let w = null;
                const b = () => {
                    let t = 0;
                    for (;Ou(d = r.charCodeAt(a)); ) {
                        t += 1 << d - 33;
                        a++;
                        if (a >= c) {
                            break;
                        }
                    }
                    return t;
                };
                do {
                    if (s === o) {
                        return;
                    }
                    w = null;
                    const g = s == e ? 2 : $(s);
                    if (g === 3) {
                        const t = s;
                        let e = s;
                        for (;e && !(w = p(e)); ) {
                            e = e.parentNode;
                        }
                        y(n, t, s, w, t.qVnodeData || "", t.qVNodeRefs);
                    } else if (g === 16) {
                        let t = s;
                        do {
                            t = n.nextNode();
                            if (!t) {
                                throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                            }
                        } while ($(t) !== 65);
                        w = null;
                    } else if (g === 64) {
                        w = s;
                        let t;
                        do {
                            w = n.nextNode();
                            if (!w) {
                                throw Error("Ignore block not closed!");
                            }
                            t = $(w);
                        } while (t !== 32 && t !== 65);
                        w = null;
                    } else if (g === 9) {
                        w = s;
                        do {
                            w = p(w);
                            if (!w) {
                                throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                            }
                        } while ($(w) !== 8);
                        y(n, s, s, w, "", null);
                    } else if (g === 6) {
                        w = p(s);
                        const n = s;
                        const e = n?.shadowRoot;
                        e && y(t.createTreeWalker(e, 129), null, e, null, "", null);
                    }
                    if ((g & 2) === 2) {
                        if (f < u) {
                            f === -1 && (f = 0);
                            a = h;
                            if (a < c) {
                                f += b();
                                const t = d === 126;
                                if (t) {
                                    m = f;
                                    a++;
                                    d = a < c ? r.charCodeAt(h) : 33;
                                }
                                h = _u(r, a, c);
                            } else {
                                f = Number.MAX_SAFE_INTEGER;
                            }
                        }
                        if (u === f) {
                            m === u && i.set(u, s);
                            const t = r.substring(a, h);
                            l.set(s, t);
                        }
                        u++;
                    }
                } while (s = w || n.nextNode());
            };
            const m = t.createTreeWalker(t, 129);
            y(m, null, m.firstChild(), null, "", null);
        }(n);
        this.re = Fe(n, this.Kn) || yi;
        this.le();
        t.setAttribute(Qe, "resumed");
        t.qContainer = this;
        t.qDestroy = () => this.mn();
        const s = t.querySelectorAll('script[type="qwik/state"]');
        if (s.length !== 0) {
            const t = s[s.length - 1];
            this.ie = JSON.parse(t.textContent);
            Jn(this.ie, this);
            this.se = ju(this, this.ie);
        }
        this.ue();
        !ie && t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    mn() {
        this.vNodeLocate = () => null;
        this.ie.length = 0;
        this.se.length = 0;
        this._ = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        t.removeAttribute(Qe);
        t.ownerDocument.qVNodeData = void 0;
    }
    ue() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(Ie);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    gn(t, n) {
        this.se[t] = n;
    }
    parseQRL(t) {
        const n = bn(t, this);
        return n;
    }
    handleError(t, n) {
        if (ee && n) {
            if (typeof document !== "undefined") {
                const e = () => {
                    const e = n;
                    const s = e.parent;
                    const o = e.nextSibling;
                    const r = [];
                    const i = ((t, n, e, s) => {
                        const o = n.createElement("errored-host");
                        s && s instanceof Error && (o.props = {
                            error: s
                        });
                        o.setAttribute("q:key", "_error_");
                        const r = to(o, "errored-host");
                        if (oo(e)) {
                            Po(t, r, e, null);
                        } else {
                            const n = [];
                            sn(t, e, t => {
                                n.push(t);
                            });
                            for (let e = 0; e < n.length; e++) {
                                Po(t, r, n[e], null);
                            }
                        }
                        return r;
                    })(r, document, e, t);
                    const c = so(e) && s || e;
                    const l = c === e ? null : o;
                    Co(r, c, i, l);
                };
                this.l ? this.l.then(e) : e();
            }
            t && t instanceof Error && ("hostElement" in t || (t.hostElement = n + ""));
            if (!(t => {
                if (t && t instanceof Error && "plugin" in t) {
                    return !1;
                }
                return !0;
            })(t)) {
                throw t;
            }
        }
        const e = n && this.resolveContext(n, Nl);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, Me);
        s == null && this.setHostProp(t, Me, s = []);
        de(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, Me);
            if (e != null && pe(e, n.id, 0)) {
                return $e(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (fo(n)) {
                if (ho(n, Ce, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        $o(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case tr:
          case Ze:
          case Ce:
          case Me:
          case Te:
            s = this._;
            break;

          case nr:
          case or:
            s = parseInt;
            break;
        }
        return ho(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                for (const t of Object.keys(n)) {
                    if (O(t)) {
                        const e = n[t];
                        if (typeof e == "string") {
                            const s = this.vNodeLocate(e);
                            n[t] = s;
                        }
                    }
                }
            }
        }
    }
    _=t => Yn(t, this.se);
    getSyncFn(t) {
        const n = this.re[t];
        return n;
    }
    ce(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, Ne);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, Ne, function r(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.oe == null) {
            this.oe = new Set;
            this.element.querySelectorAll(Pe).forEach(t => {
                this.oe.add(t.getAttribute(Ae));
            });
        }
        if (!this.oe.has(n)) {
            this.oe.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(Ae, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    le() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === ur) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.Ft = {
            containerAttributes: t
        };
    }
}

const Iu = (t, n) => {
    const {val: e, set: s, iCtx: o, i: r} = El();
    if (e) {
        return;
    }
    s(1);
    const i = n?.deferUpdates === !1 ? 0 : 8;
    const c = new Mu(6 | i, r, o.p, t, void 0, null);
    s(c);
    const l = o.O;
    const {gt: u} = o;
    const f = $r(u, () => Nu(c, l, o.p));
    hr(f) && (o.gt = f);
};

const Nu = (t, n, e) => {
    const s = t.fe;
    if (s) {
        return s;
    }
    t.R &= -5;
    const o = t => n.handleError(t, e);
    let r = null;
    const i = $r(((t, n) => {
        const e = t.ae;
        if (e) {
            return e;
        }
        const s = t.mn;
        if (!s) {
            return;
        }
        t.mn = null;
        try {
            const e = s();
            if (hr(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.ae === s && (t.ae = void 0);
                });
                t.ae = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = yn(n.wt, e, "qTask");
        s.O = n;
        const i = t.Pt.getFn(s, () => p(n, t));
        const c = _i(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.mn = () => {
                            t.mn = null;
                            let s = null;
                            for (const t of e) {
                                try {
                                    const e = t();
                                    hr(e) && (s ||= []).push(e.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return dr(() => i(u), l, s => {
            if (hr(s)) {
                return s.then(() => {
                    t.fe === r && (t.fe = null);
                    return Nu(t, n, e);
                });
            }
            o(s);
        });
    });
    if (hr(i)) {
        r = i.finally(() => {
            t.fe === r && (t.fe = null);
        });
        t.fe = r;
        return r;
    }
    return i;
};

class Mu extends Kr {
    R;
    Pn;
    $t;
    Pt;
    Tt;
    mn;
    ae;
    fe=null;
    constructor(t, n, e, s, o, r) {
        super();
        this.R = t;
        this.Pn = n;
        this.$t = e;
        this.Pt = s;
        this.Tt = o;
        this.mn = r;
    }
}

const Tu = t => t instanceof Mu;

function Dn(t, n) {
    const e = Tn(n);
    typeof this === "string" && qc(Rc(e, this));
    const s = xc[0];
    s.R |= 4;
    nn(e, s.$t, 1);
}

const Fu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const zu = t => t instanceof ci;

const Du = (t, n) => {
    t.add(n);
};

const Lu = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Uu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Tu(e) ? o = e.Pt : e instanceof Ai ? o = e.Yt : s === ":" && (o = n.getHostProp(e, Ce));
        o && n.serializationCtx.At.add(o);
    }
};

const Wu = (t, n, e) => {
    const s = import.meta.env.TEST ? !Vr() : !Kn;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const r = e.property;
            if (Tu(o)) {
                o.R |= 4;
                nn(t, o.$t, 1);
            } else if (o instanceof ci) {
                o.invalidate();
            } else if (r === ":") {
                nn(t, o, 4);
            } else if (r === ".") {
                if (s) {
                    It(o, n);
                    nn(t, o, 2);
                }
            } else {
                const i = e.data;
                if (i instanceof Xi) {
                    const e = i.data;
                    const c = {
                        isConst: e.lt,
                        scopedStyleIdPrefix: e.W,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[oi];
                            if (!o) {
                                o = new Map;
                                s[oi] = o;
                            }
                            o.set(n, e);
                        })(o, r, c);
                    } else {
                        const t = o;
                        let n = t.getProp(oi);
                        if (!n) {
                            n = new Map;
                            t.setProp(oi, n);
                        }
                        n.set(r, c);
                    }
                    nn(t, o, 8);
                }
            }
        };
        const r = Array.from(e);
        for (let t = 0; t < r.length; t++) {
            o(r[t]);
        }
    }
};

const Qu = t => me(t) && typeof t[yc] === "function";

const Vu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Ju = [];

function Ln(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Tu(t)) {
            return `Task(${Ln(t.Pt)})`;
        }
        if (ke(t)) {
            return `Qrl(${t.St})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Ju.includes(t)) {
                return "*";
            }
            try {
                Ju.push(t);
                if (Array.isArray(t)) {
                    return io(t) ? "(" + (ho(t, xe, null) || "vnode") + ")" : t.map(Ln);
                }
                if (zu(t)) {
                    return t instanceof Gi ? "WrappedSignal" : t instanceof Ai ? "ComputedSignal" : "Signal";
                }
                if (Zu(t)) {
                    return "Store";
                }
                if (es(t)) {
                    return Bu(t);
                }
                if (io(t)) {
                    return "(" + (ho(t, xe, null) || "vnode") + ")";
                }
            } finally {
                Ju.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Bu = t => {
    if (es(t)) {
        if (typeof t.type === "function") {
            const n = t.type[Wc];
            if (n) {
                const [t] = n;
                return "Component(" + t.St + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            for (const [e, s] of Object.entries(t.props)) {
                n += " " + e + "=" + Ln(s);
            }
            const e = t.children;
            if (e != null) {
                n += ">";
                Array.isArray(e) ? e.forEach(t => {
                    n += Bu(t);
                }) : n += Bu(e);
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Hu = t => t[Ei];

const Yu = t => t?.[ji] || null;

const Gu = (t, n) => {
    const e = Hu(t);
    e && e.force(n);
};

const Xu = (t, n) => {
    const e = Hu(t);
    if (e) {
        return (e.$?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Ku = t => Yu(t) || t;

const Zu = t => ji in t;

function Un(t, n, e) {
    return new Proxy(n, new nc(e, t || null));
}

const tc = (t, n, e) => {
    if (ye(t) && e) {
        let s = e.h.get(t);
        if (!s) {
            s = Un(e, t, n);
            e.h.set(t, s);
        }
        return s;
    }
    return t;
};

class nc {
    R;
    O;
    $=void 0;
    constructor(t, n) {
        this.R = t;
        this.O = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Yu(this);
        Wu(this.O, this, Vn(n, t, this.$));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === ji) {
                return t;
            }
            if (n === Ei) {
                return this;
            }
            return t[n];
        }
        const e = ml();
        const s = t[n];
        if (e) {
            if (this.O === null) {
                if (!e.O) {
                    return s;
                }
                this.O = e.O;
            }
            const o = e.vt;
            o && Wn(t, Array.isArray(t) ? Oi : n, this, o);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.R;
        if (o & 1 && me(s) && !Object.isFrozen(s) && !Zu(s) && !Object.isFrozen(t)) {
            return tc(s, this.R, this.O);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.R & 1 ? Ku(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Qn(n, s, t, this);
        } else {
            Qn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Wu(this.O, this, Vn(t, n, this.$));
        return !0;
    }
    has(t, n) {
        if (n === ji) {
            return !0;
        }
        if (typeof n === "string") {
            const e = ml();
            if (e) {
                const s = e.vt;
                s && Wn(t, Array.isArray(t) ? Oi : n, this, s);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = ml();
        const e = n?.vt;
        e && Wn(t, Oi, this, e);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function Wn(t, n, e, s) {
    const o = e.$ ||= new Map;
    let r = o.get(n);
    if (!r) {
        r = new Set;
        o.set(n, r);
    }
    Du(r, s);
    Lu(s, t);
    (import.meta.env.TEST ? !Au(e.O) : Kn) && Uu(s, e.O);
}

function Qn(t, n, e, s) {
    e[t] = n;
    const o = Vn(e, t, s.$);
    o && Wu(s.O, s, o);
}

function Vn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Oi);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const ec = (t, n) => t[n];

const rc = (t, n = new WeakSet) => {
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const e = Object.getPrototypeOf(t);
        Zu(t) && (t = Yu(t));
        if (e == Object.prototype) {
            for (const e in t) {
                if (!rc(vl(ec, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (e == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!rc(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Tu(t)) {
            return !0;
        }
        if (qi(t)) {
            return !0;
        }
        if (hr(t)) {
            return !0;
        }
        if (es(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Xi) {
            return !0;
        }
        if (eu?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (ke(t) || Qc(t) || t === ws || t === ps) {
            return !0;
        }
    } else if (t === pi || t === Ri || t === Oi) {
        return !0;
    }
    return !1;
};

const ic = (t, n) => {
    let e = io(t) ? cn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (me(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let sc = !1;

const oc = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const r = n ? "[0m" : "";
    const i = e === "";
    const c = [];
    for (let i = 0; i < t.length; i++) {
        if (s && i > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[i];
        let u = t[++i];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && (sc = !0);
            const n = `{${me(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${r} ${ic(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = uc(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${oc(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${lc(l)}${r} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${i ? n + " " : ""}${t}`).join("\n");
    if (i) {
        const n = sc ? "" : `(${JSON.stringify(t).length} chars)`;
        sc = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const lc = t => Fl[t] || `Unknown(${t})`;

const uc = t => Tl[t] || `Unknown(${t})`;

function Jn(t, n) {
    const e = (t, n) => t === 1 && typeof n === "string";
    const s = t => t === 14;
    const o = n => {
        const e = t[n + 1].split(" ");
        let s = t;
        let o = 1;
        let r = 0;
        let i = 0;
        let c = null;
        for (let n = 0; n < e.length; n++) {
            c = s;
            r = parseInt(e[n], 10) * 2;
            i = r + 1;
            o = s[r];
            s = s[i];
            if (o === 1) {
                const n = s;
                const e = n * 2;
                o = t[e];
                s = t[e + 1];
            }
        }
        if (c) {
            c[r] = 1;
            c[i] = n / 2;
        }
        t[n] = o;
        t[n + 1] = s;
    };
    for (let r = 0; r < t.length; r += 2) {
        e(t[r], t[r + 1]) ? o(r) : s(t[r]) && (n.It = t[r + 1]);
    }
}

async function Bn(t) {
    const n = su(null, null, () => "", () => {}, new WeakMap);
    n.Rt(t);
    await n.Nt();
    return "" + n.Mt;
}

function Hn(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = function s(t) {
        let n;
        const e = {
            _: t => Yn(t, n),
            getSyncFn: () => () => {},
            h: new WeakMap,
            element: null,
            It: null
        };
        Jn(t, e);
        n = ju(e, t);
        e.Tt = n;
        return e;
    }(n);
    return In(e, n[0], n[1]);
}

function Yn(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

const cc = (t, n) => {
    const e = new WeakSet;
    return vl(fc, t, e, "_", n);
};

const fc = (t, n, e, s) => {
    const o = Ku(t);
    if (o == null) {
        return t;
    }
    if (hc(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (zu(o)) {
            return t;
        }
        if (rc(o)) {
            return t;
        }
        const r = typeof o;
        switch (r) {
          case "object":
            if (hr(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (we(o)) {
                let s = 0;
                o.forEach((t, r) => {
                    if (r !== s) {
                        throw ge(3, [ o ]);
                    }
                    fc(t, n, e + "[" + r + "]");
                    s = r + 1;
                });
                return t;
            }
            if (o.__brand) {
                return t;
            }
            if (ye(o)) {
                for (const [t, s] of Object.entries(o)) {
                    fc(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let i;
        i = s || "Value cannot be serialized";
        e !== "_" && (i += ` in ${e},`);
        if (r === "object") {
            i += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (r === "function") {
            const n = t.name;
            i += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw ge(3, [ i ]);
    }
    return t;
};

const ac = /*#__PURE__*/ new WeakSet;

const hc = t => {
    if (me(t) || ve(t)) {
        return !ac.has(t) && !(pc in t);
    }
    return !0;
};

const dc = t => !!t && (me(t) || typeof t === "function") && (ac.has(t) || pc in t);

const $c = t => {
    (me(t) && t !== null || typeof t === "function") && ac.add(t);
    return t;
};

const pc = Symbol();

const yc = Symbol();

class mc {
    kt;
    St;
    he;
    te;
    O;
    dev;
    constructor(t, n, e, s, o) {
        this.kt = t;
        this.St = n;
        this.he = e;
        this.te = s;
        s && this.de(s);
        !o || s || typeof t !== "string" || e || (this.O = o);
        ee && (this.dev = null);
        Zn && t && Xn(t, .8);
    }
    get ft() {
        return ya(this.St);
    }
    de(t) {
        this.te = t;
        hr(t) && t.then(t => this.te = t, t => {
            console.error(`qrl ${this.St} failed to load`, t);
            this.te = null;
        });
    }
    $e() {
        if (this.te != null) {
            return this.te;
        }
        if (this.kt === "") {
            const t = this.O.Kn;
            const n = this.O.element?.ownerDocument || document;
            const e = Fe(n, t);
            return this.te = e[+this.St];
        }
        Zn && this.kt && Xn(this.kt, 1);
        const t = this.St;
        const n = this.he ? this.he().then(n => n[t]) : Qr().importSymbol(this.O?.element, this.kt, t);
        this.de(n);
        return this.te;
    }
}

const wc = Symbol();

const bc = t => t?.[wc] ?? t;

class vc {
    Sn;
    resolved=void 0;
    Ot;
    O;
    constructor(t, n, e) {
        this.Sn = t;
        if (n) {
            this.Ot = n;
            typeof n === "string" && (this.O = e);
            if (ee && n && typeof n === "object") {
                for (const t of n) {
                    cc(t, "Captured variable in the closure can not be serialized");
                }
            }
        }
        t.te == null || typeof this.Ot === "string" || hr(t.te) || (this.resolved = jc(this, t.te));
    }
}

const gc = function(t, ...n) {
    const e = bc(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = ml();
    return Sc.call(e, s?.O).then(() => $n.call(t, s, e.resolved, n));
};

const Sc = async function(t) {
    const n = bc(this);
    return $r(Ec(n, t), () => n.resolved);
};

const kc = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[wc].resolved;
        },
        set(t) {
            this[wc].resolved = t;
        }
    },
    Ot: {
        get() {
            return this[wc].Ot;
        },
        set(t) {
            this[wc].Ot = t;
        }
    },
    O: {
        get() {
            return this[wc].O;
        },
        set(t) {
            this[wc].O = t;
        }
    },
    Sn: {
        get() {
            return this[wc].Sn;
        }
    },
    kt: {
        get() {
            return this[wc].Sn.kt;
        }
    },
    St: {
        get() {
            return this[wc].Sn.St;
        }
    },
    ft: {
        get() {
            return this[wc].Sn.ft;
        }
    },
    dev: {
        get() {
            return this[wc].Sn.dev;
        }
    },
    pe: {
        value: gc
    },
    w: {
        value: function(t) {
            const n = bc(this);
            const e = new vc(n.Sn, t, n.Ot ? n.O : void 0);
            return _c(e);
        }
    },
    s: {
        value: function(t) {
            const n = bc(this);
            n.Sn.de(t);
            n.resolved = jc(n, t);
        }
    },
    resolve: {
        value: Sc
    },
    getSymbol: {
        value: function() {
            return bc(this).Sn.St;
        }
    },
    getHash: {
        value: function() {
            return bc(this).Sn.ft;
        }
    },
    getCaptured: {
        value: function() {
            const t = bc(this);
            Cc(t);
            return t.Ot;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = bc(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Sc.call(e).then(t => {
                        if (ee && !ve(t)) {
                            throw ge(5);
                        }
                        return s(...o);
                    });
                }
                if (n && n() === !1) {
                    return;
                }
                return $n(t, e.resolved, o);
            };
            return s;
        }
    }
});

let xc = null;

const qc = t => {
    xc = t;
};

const Rc = (t, n) => {
    const e = [];
    for (const s of n.split(" ")) {
        e.push(t._(s));
    }
    return e;
};

const Cc = t => {
    xc = t.Ot;
    const n = t.O;
    if (typeof xc === "string") {
        if (!n) {
            throw ge(13);
        }
        const e = vu;
        xc = t.Ot = Rc(n, xc);
        if (vu !== e) {
            return vu;
        }
    }
};

const jc = (t, n) => {
    if (typeof n !== "function" || !t.Ot) {
        return n;
    }
    return function e(...s) {
        Cc(t);
        return n.apply(this, s);
    };
};

const Ec = (t, n) => {
    const e = t.Sn;
    const s = typeof t.Ot === "string";
    s && !t.O && (t.O = n || ml()?.O);
    if (t.resolved) {
        return;
    }
    const o = Nc();
    const r = ml();
    const i = e.$e();
    const c = $r(i, n => {
        t.resolved = jc(t, n);
    });
    if (c) {
        const t = e.St;
        Pc(t, r?.p instanceof ni ? r?.p.node : void 0, o);
    }
    const l = s && t.O && Cc(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const Oc = (t, n, e, s, o, r) => {
    const i = new mc(t, n, s, e, r);
    const c = new vc(i, o, r);
    return _c(c);
};

const _c = t => {
    const n = async function(...t) {
        return gc.call(n, this, ...t);
    };
    n[wc] = t;
    Object.setPrototypeOf(n, kc);
    return n;
};

const Ac = /*#__PURE__*/ new Set;

const Pc = (t, n, e) => {
    if (!Ac.has(t)) {
        Ac.add(t);
        Ic("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const Ic = (t, n) => {
    ie || Vr() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const Nc = () => {
    if (ie || Vr()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let Mc = 0;

const Tc = t => {
    if (!se && ee) {
        throw Error("Optimizer should replace all usages of $() with some special syntax. If you need to create a QRL manually, use inlinedQrl() instead.");
    }
    return Oc(null, "s" + Mc++, t, null, null);
};

const Fc = Tc;

const zc = t => t;

const Dc = t => {
    if (!se && ee) {
        throw Error("Optimizer should replace all usages of sync$() with some special syntax. If you need to create a QRL manually, use inlinedSyncQrl() instead.");
    }
    ee && (t = Function("return " + t)());
    return Oc("", Se, t, null, null);
};

const Lc = (t, n) => {
    n === void 0 && (n = "" + t);
    t.serialized = n;
    return Oc("", Se, t, null, null);
};

const Uc = t => {
    function n(n, e, s = 0) {
        const o = ie ? "sX" : t.ft.slice(0, 4);
        const r = o + ":" + (e || "");
        const i = () => {};
        i[Wc] = [ t ];
        return ls(i, n, null, n.children, s, r);
    }
    n[Wc] = [ t ];
    return n;
};

const Wc = Symbol();

const Qc = t => typeof t == "function" && t[Wc] !== void 0;

const Vc = t => Uc(Fc(t));

const Jc = Ni(zc);

const Bc = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !Jr(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    if (ee && t.hasAttribute(Qe)) {
        throw ge(4, [ t ]);
    }
    t.setAttribute(Qe, "resumed");
    const s = Tn(t);
    s.Ft = e.serverData || {};
    const o = s.rootVNode;
    $o(o, li, n);
    nn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            St(s, [], s.rootVNode);
        }
    };
};

const Hc = (t, n) => {
    const {val: e, set: s, iCtx: o} = El();
    if (e != null) {
        return e;
    }
    const r = ve(t) ? dn(void 0, t) : t;
    if (n?.reactive === !1) {
        s(r);
        return r;
    }
    {
        const t = o.O;
        const e = n?.deep ?? !0;
        const i = e ? 1 : 0;
        const c = tc(r, i, t);
        s(c);
        return c;
    }
};

const Yc = () => {
    const {val: t, set: n, iCtx: e} = El();
    if (t != null) {
        return t;
    }
    const s = e.O.Zn || "";
    const o = s ? gr(s).substring(0, 3) : "";
    const r = e.O.getHostProp(e.p, Ce);
    const i = r?.getHash().substring(0, 3) || "";
    const c = (t => (t => t.toString(36))(t.Xn++))(e.O) || "";
    let l = `${o}${i}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function Gn(t, n) {
    const e = ml();
    return e?.O?.Ft[t] ?? n;
}

const Gc = /*#__PURE__*/ new Map;

const Xc = (t, n) => {
    if (ee) {
        return Kc(t, n);
    }
    let e = Gc.get(n);
    e || Gc.set(n, e = Kc(t, n));
    return e;
};

const Kc = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let r = 0;
    let i = r;
    let c = rf;
    let l = 0;
    for (;r < e; ) {
        const n = r;
        let e = t.charCodeAt(r++);
        if (e === _f) {
            r++;
            e = jf;
        }
        const s = zf[c];
        for (let d = 0; d < s.length; d++) {
            const $ = s[d];
            const [p, y, m] = $;
            if ((p === l || p === df || p === $f && Zc(l) || p === yf && ef(l)) && (y === e || y === df || y === $f && Zc(e) || y === pf && !Zc(e) && e !== xf || y === yf && ef(e)) && ($.length == 3 || a($))) {
                $.length > 3 && (e = t.charCodeAt(r - 1));
                if (m === af || m == hf) {
                    if (m === hf) {
                        if (c !== sf || h()) {
                            if (!tf(e)) {
                                const t = y == pf ? 1 : y == Sf ? 2 : 0;
                                f(r - t);
                            }
                        } else {
                            tf(e) ? u(r - 2) : f(r - 2);
                            i++;
                        }
                    }
                    if (y === pf) {
                        r--;
                        e = l;
                    }
                    do {
                        c = o.pop() || rf;
                        if (c === of) {
                            u(r - 1);
                            i++;
                        }
                    } while (nf(c));
                } else {
                    o.push(c);
                    if (c === of && m === rf) {
                        u(r - 8);
                        i = r;
                    } else {
                        m === lf && f(n);
                    }
                    c = m;
                }
                break;
            }
        }
        l = e;
    }
    u(r);
    return s.join("");
    function u(n) {
        s.push(t.substring(i, n));
        i = n;
    }
    function f(t) {
        if (c === of || h()) {
            return;
        }
        u(t);
        s.push(".", Ee, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(r) === kf) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(r + n) === kf) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(r + n + e) | Pf) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            r += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(of) !== -1 || o.indexOf(uf) !== -1;
    }
};

const Zc = t => t >= qf && t <= Rf || t >= jf && t <= Ef || t >= If && t <= Nf || t >= 128 || t === Af || t === kf;

const tf = t => t === Cf || t === xf || t === Of || t === gf || Zc(t);

const nf = t => t === cf || t === uf || t === ff || t === of;

const ef = t => t === vf || t === mf || t === wf || t === bf;

const rf = 0;

const sf = 2;

const of = 5;

const lf = 6;

const uf = 10;

const cf = 11;

const ff = 12;

const af = 17;

const hf = 18;

const df = 0;

const $f = 1;

const pf = 2;

const yf = 3;

const mf = 9;

const wf = 10;

const bf = 13;

const vf = 32;

const gf = 35;

const Sf = 41;

const kf = 45;

const xf = 46;

const qf = 48;

const Rf = 57;

const Cf = 58;

const jf = 65;

const Ef = 90;

const Of = 91;

const _f = 92;

const Af = 95;

const Pf = 32;

const If = 97;

const Nf = 122;

const Mf = 123;

const Tf = 125;

const Ff = /*@__PURE__*/ (() => [ [ df, 39, 14 ], [ df, 34, 15 ], [ df, 47, 16, "*" ] ])();

const zf = /*@__PURE__*/ (() => [ [ [ df, 42, sf ], [ df, Of, 7 ], [ df, Cf, lf, ":", "before", "after", "first-letter", "first-line" ], [ df, Cf, of, "global" ], [ df, Cf, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ df, Cf, 4 ], [ df, $f, 1 ], [ df, xf, 1 ], [ df, gf, 1 ], [ df, 64, uf, "keyframe" ], [ df, 64, cf, "media", "supports", "container" ], [ df, 64, ff ], [ df, Mf, 13 ], [ 47, 42, 16 ], [ df, 59, af ], [ df, Tf, af ], [ df, Sf, af ], ...Ff ], [ [ df, pf, hf ] ], [ [ df, pf, hf ] ], [ [ df, 40, rf ], [ df, pf, hf ] ], [ [ df, 40, 8 ], [ df, pf, hf ] ], [ [ df, 40, rf ], [ df, pf, af ] ], [ [ df, pf, af ] ], [ [ df, 93, hf ], [ df, 39, 14 ], [ df, 34, 15 ] ], [ [ df, Sf, af ], ...Ff ], [ [ df, Tf, af ], ...Ff ], [ [ df, Tf, af ], [ yf, $f, 1 ], [ df, Cf, of, "global" ], [ df, Mf, 13 ], ...Ff ], [ [ df, Mf, rf ], [ df, 59, af ], ...Ff ], [ [ df, 59, af ], [ df, Mf, 9 ], ...Ff ], [ [ df, Tf, af ], [ df, Mf, 13 ], [ df, 40, 8 ], ...Ff ], [ [ df, 39, af ] ], [ [ df, 34, af ] ], [ [ 42, 47, af ] ] ])();

const Df = t => ({
    styleId: Qf(t, t => t, !1)
});

const Lf = /*#__PURE__*/ Ni(Df);

const Uf = t => ({
    scopeId: Ee + Qf(t, Xc, !0)
});

const Wf = /*#__PURE__*/ Ni(Uf);

const Qf = (t, n, e) => {
    const {val: s, set: o, iCtx: r, i} = El();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${gr(t.ft)}-${n}`)(t, i);
    const l = r.p;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => r.O.ce(n(t, c), c, l, e));
    }
    r.O.ce(n(t.resolved, c), c, l, e);
    return c;
};

const Vf = t => {
    const n = ve(t) && !Qc(t) ? dn(void 0, t) : t;
    return Di(n);
};

const Jf = t => Bf(Vf, t);

const Bf = (t, ...n) => {
    const {val: e, set: s} = El();
    if (e != null) {
        return e;
    }
    t = ve(t) && !Qc(t) ? vl(t, ...n) : t;
    return s(t);
};

const Hf = (t, n) => {
    t.resolve();
    return Ti(t, n);
};

const Yf = (t, n) => Bf(Hf, t, n);

const Gf = Ni(Yf);

const Xf = t => {
    t.resolve();
    return zi(t);
};

const Kf = t => Bf(Xf, t);

const Zf = Ni(Kf);

const ta = (t, n) => {
    const {val: e, set: s, i: o, iCtx: r} = El();
    const i = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.R & 32) && !Vr()) {
            e.R |= 32;
            na(e, i);
        }
        return;
    }
    let c;
    if (Vr()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        nn(r.O, r.p, 1);
    }
    const l = new Mu(c, o, r.p, t, void 0, null);
    s(l);
    na(l, i);
};

const na = (t, n) => {
    n === "intersection-observer" ? du("qvisible", ea(t)) : n === "document-ready" ? $u("qinit", ea(t)) : n === "document-idle" && $u("qidle", ea(t));
};

const ea = t => Oc(null, "_task", Dn, null, [ t ]);

const ra = Ni(fu);

const ia = /*#__PURE__*/ Ni(Iu);

const sa = /*#__PURE__*/ Ni(ta);

const oa = (t, n) => {
    t.resolve();
    return Fi(t, n);
};

const la = (t, n) => Bf(oa, t, n);

const ua = Ni(la);

const ca = () => {
    const t = Hc({
        error: void 0
    });
    _l(Nl, t);
    return t;
};

const fa = async ({track: t}) => {
    const n = xc[0];
    t(() => n.items);
    const e = ml();
    const s = e.p;
    const o = e.O;
    nn(o, s, 128);
    const r = import.meta.env.TEST ? Vr() : Kn;
    r && await o.l;
};

const aa = t => {
    Iu(/*#__PURE__*/ Wl(fa, "_eaT", [ t ]));
    return bs;
};

const ha = /*#__PURE__*/ Uc(
/*#__PURE__*/ Wl(aa, "_eaC"));

const da = t => {
    import.meta;
    const n = import.meta.env.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    e.path = t?.path?.startsWith?.("/") ? t.path : n + e.path;
    let s = $a.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return os("script", null, o, null, 0, "prefetch-service-worker");
};

const $a = /*#__PURE__*/ "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        t.forEach(t => {
            t.active && t.active.scriptURL.endsWith("_URL_") && t.unregister().catch(console.error);
        });
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const pa = () => null;

globalThis.__qwik && ge(30, [ globalThis.__qwik, zr ]);

globalThis.__qwik = zr;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { Tc as $, ha as Each, ps as Fragment, pc as NoSerializeSymbol, pa as PrefetchGraph, da as PrefetchServiceWorker, ys as RenderOnce, au as Resource, gs as SSRComment, vs as SSRRaw, ks as SSRStream, Ss as SSRStreamBlock, yc as SerializerSymbol, bs as SkipRender, ws as Slot, fi as _CONST_PROPS, Pu as _DomContainer, Xr as _EFFECT_BACK_REF, yi as _EMPTY_ARRAY, mi as _EMPTY_OBJ, $i as _IMMUTABLE, ou as _SharedContainer, Xi as _SubscriptionData, pi as _UNINITIALIZED, ai as _VAR_PROPS, On as _addProjection, xc as _captures, g as _chk, Oc as _createQRL, Hn as _deserialize, oc as _dumpState, aa as _eaC, fa as _eaT, Zt as _executeSsrChores, Yl as _fnSignal, xi as _getConstProps, Rl as _getContextContainer, ql as _getContextEvent, xl as _getContextHostElement, Tn as _getDomContainer, zn as _getQContainerElement, ki as _getVarProps, Xu as _hasStoreEffects, wu as _hmr, es as _isJSXNode, Zu as _isStore, gn as _isStringifiable, Tu as _isTask, Cl as _jsxBranch, us as _jsxC, fs as _jsxQ, cs as _jsxS, os as _jsxSorted, ls as _jsxSplit, he as _mapApp_findIndx, $e as _mapArray_get, de as _mapArray_set, Ql as _noopQrl, Vl as _noopQrlDEV, Jn as _preprocessState, Lc as _qrlSync, mn as _qrlToString, Hl as _regSymbol, Pn as _removeProjection, S as _res, Il as _resolveContextWithoutSequentialScope, Cs as _restProps, cu as _rsc, A as _run, Bn as _serialize, Cn as _setEvent, _n as _setProjectionTarget, Dn as _task, An as _updateProjectionProps, En as _useHmr, v as _val, cc as _verifySerializable, mo as _vnode_ensureElementInflated, sl as _vnode_getAttrKeys, Lo as _vnode_getFirstChild, uo as _vnode_isMaterialized, co as _vnode_isTextVNode, fo as _vnode_isVirtualVNode, cn as _vnode_toString, jl as _waitUntilRendered, qn as _walkJSX, Bi as _wrapProp, Yi as _wrapSignal, Vc as component$, Uc as componentQrl, Ui as createAsync$, Fi as createAsyncQrl, Li as createComputed$, Ti as createComputedQrl, Ol as createContextId, k as createElement, Wi as createSerializer$, zi as createSerializerQrl, Di as createSignal, Jc as event$, zc as eventQrl, Gu as forceStoreEffects, Tn as getDomContainer, an as getLocale, Qr as getPlatform, k as h, Ni as implicit$FirstArg, Wl as inlinedQrl, Bl as inlinedQrlDEV, te as isDev, zu as isSignal, hs as jsx, ds as jsxDEV, $s as jsxs, $c as noSerialize, Ul as qrl, Jl as qrlDEV, Bc as render, Wr as setPlatform, Dc as sync$, vl as untrack, Ku as unwrapStore, ua as useAsync$, la as useAsyncQrl, Gf as useComputed$, Yf as useComputedQrl, Bf as useConstant, Al as useContext, _l as useContextProvider, ca as useErrorBoundary, Yc as useId, uu as useLexicalScope, du as useOn, $u as useOnDocument, pu as useOnWindow, ra as useResource$, fu as useResourceQrl, Zf as useSerializer$, Kf as useSerializerQrl, Gn as useServerData, Jf as useSignal, Hc as useStore, Lf as useStyles$, Df as useStylesQrl, Wf as useStylesScoped$, Uf as useStylesScopedQrl, ia as useTask$, Iu as useTaskQrl, sa as useVisibleTask$, ta as useVisibleTaskQrl, zr as version, hn as withLocale };
